import React, { useState, useEffect } from 'react';

export const AddNotesillus = () => {
  const [primaryColor, setPrimaryColor] = useState('#ffd800');

  const storedTheme = JSON.parse(localStorage.getItem('themeSettings')) || '';

  useEffect(() => {
    if (storedTheme !== '') {
      setPrimaryColor(storedTheme?.primaryColor);
    }
  }, [storedTheme]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="188.801"
      viewBox="0 0 627.5 188.801"
    >
      <g
        id="Group_41171"
        data-name="Group 41171"
        transform="translate(-23722 -5132.843)"
      >
        <g
          id="Group_41170"
          data-name="Group 41170"
          transform="translate(22428.5 4246.536)"
        >
          <g id="Floor" transform="translate(1294 1051.18)">
            <line
              id="Line_90"
              data-name="Line 90"
              x2="626.5"
              transform="translate(0)"
              fill="none"
              stroke="#263238"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
          </g>
          <g
            id="Group_5032"
            data-name="Group 5032"
            transform="translate(1794 -5991.607)"
          >
            <g
              id="Background_Complete"
              data-name="Background Complete"
              transform="translate(-106.525 6877.915)"
            >
              <g
                id="Group_4488"
                data-name="Group 4488"
                transform="translate(-355.474 0)"
              >
                <g id="Group_4337" data-name="Group 4337">
                  <g
                    id="Group_4331"
                    data-name="Group 4331"
                    transform="translate(0.169 0.169)"
                  >
                    <g id="Group_4330" data-name="Group 4330">
                      <g id="Group_4329" data-name="Group 4329">
                        <g id="Group_4328" data-name="Group 4328">
                          <rect
                            id="Rectangle_2732"
                            data-name="Rectangle 2732"
                            width="63.099"
                            height="56.452"
                            fill="#fafafa"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_4336" data-name="Group 4336">
                    <g id="Group_4335" data-name="Group 4335">
                      <g id="Group_4334" data-name="Group 4334">
                        <g id="Group_4333" data-name="Group 4333">
                          <g id="Group_4332" data-name="Group 4332">
                            <path
                              id="Path_16056"
                              data-name="Path 16056"
                              d="M114.374,102.218s-.011-.362-.016-1.047-.009-1.706-.016-3.025c-.008-2.65-.021-6.525-.037-11.459-.018-9.864-.043-23.958-.074-40.92l.143.143-63.093.026h-.006l.169-.169c-.007,20.538-.014,39.864-.02,56.452l-.149-.149,45.638.075,12.872.039,3.408.017.879.008c.2,0,.3.008.3.008s-.093.006-.286.008l-.862.008-3.379.017-12.839.039-45.733.075h-.148v-.149c-.006-16.588-.013-35.914-.02-56.452V45.6h.174l63.093.026h.143v.143c-.031,17-.056,31.125-.074,41.011-.016,4.921-.028,8.784-.037,11.427-.007,1.307-.012,2.311-.016,3S114.374,102.218,114.374,102.218Z"
                              transform="translate(-51.106 -45.597)"
                              fill="#e0e0e0"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4342"
                  data-name="Group 4342"
                  transform="translate(9.528 10.03)"
                >
                  <g id="Group_4341" data-name="Group 4341">
                    <g id="Group_4340" data-name="Group 4340">
                      <g id="Group_4339" data-name="Group 4339">
                        <g id="Group_4338" data-name="Group 4338">
                          <path
                            id="Path_16057"
                            data-name="Path 16057"
                            d="M87.362,68.317c0,.093-3.321.169-7.417.169s-7.418-.076-7.418-.169,3.321-.169,7.418-.169S87.362,68.224,87.362,68.317Z"
                            transform="translate(-72.527 -68.148)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4347"
                  data-name="Group 4347"
                  transform="translate(10.343 14.269)"
                >
                  <g id="Group_4346" data-name="Group 4346">
                    <g id="Group_4345" data-name="Group 4345">
                      <g id="Group_4344" data-name="Group 4344">
                        <g id="Group_4343" data-name="Group 4343">
                          <path
                            id="Path_16058"
                            data-name="Path 16058"
                            d="M115.116,77.847c0,.093-9.124.169-20.377.169S74.36,77.94,74.36,77.847s9.122-.169,20.379-.169S115.116,77.754,115.116,77.847Z"
                            transform="translate(-74.36 -77.678)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4351"
                  data-name="Group 4351"
                  transform="translate(9.637 21.618)"
                >
                  <g id="Group_4350" data-name="Group 4350">
                    <g id="Group_4349" data-name="Group 4349">
                      <g id="Group_4348" data-name="Group 4348">
                        <rect
                          id="Rectangle_2733"
                          data-name="Rectangle 2733"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4355"
                  data-name="Group 4355"
                  transform="translate(16.18 21.618)"
                >
                  <g id="Group_4354" data-name="Group 4354">
                    <g id="Group_4353" data-name="Group 4353">
                      <g id="Group_4352" data-name="Group 4352">
                        <rect
                          id="Rectangle_2734"
                          data-name="Rectangle 2734"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4359"
                  data-name="Group 4359"
                  transform="translate(22.845 21.497)"
                >
                  <g id="Group_4358" data-name="Group 4358">
                    <g id="Group_4357" data-name="Group 4357">
                      <g id="Group_4356" data-name="Group 4356">
                        <rect
                          id="Rectangle_2735"
                          data-name="Rectangle 2735"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4363"
                  data-name="Group 4363"
                  transform="translate(29.267 21.618)"
                >
                  <g id="Group_4362" data-name="Group 4362">
                    <g id="Group_4361" data-name="Group 4361">
                      <g id="Group_4360" data-name="Group 4360">
                        <rect
                          id="Rectangle_2736"
                          data-name="Rectangle 2736"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4367"
                  data-name="Group 4367"
                  transform="translate(35.811 21.618)"
                >
                  <g id="Group_4366" data-name="Group 4366">
                    <g id="Group_4365" data-name="Group 4365">
                      <g id="Group_4364" data-name="Group 4364">
                        <rect
                          id="Rectangle_2737"
                          data-name="Rectangle 2737"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4371"
                  data-name="Group 4371"
                  transform="translate(42.355 21.618)"
                >
                  <g id="Group_4370" data-name="Group 4370">
                    <g id="Group_4369" data-name="Group 4369">
                      <g id="Group_4368" data-name="Group 4368">
                        <rect
                          id="Rectangle_2738"
                          data-name="Rectangle 2738"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4375"
                  data-name="Group 4375"
                  transform="translate(48.898 21.618)"
                >
                  <g id="Group_4374" data-name="Group 4374">
                    <g id="Group_4373" data-name="Group 4373">
                      <g id="Group_4372" data-name="Group 4372">
                        <rect
                          id="Rectangle_2739"
                          data-name="Rectangle 2739"
                          width="2.658"
                          height="2.658"
                          fill="#ebebeb"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4379"
                  data-name="Group 4379"
                  transform="translate(9.637 27.269)"
                >
                  <g id="Group_4378" data-name="Group 4378">
                    <g id="Group_4377" data-name="Group 4377">
                      <g id="Group_4376" data-name="Group 4376">
                        <rect
                          id="Rectangle_2740"
                          data-name="Rectangle 2740"
                          width="2.658"
                          height="2.658"
                          fill="#ebebeb"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4383"
                  data-name="Group 4383"
                  transform="translate(16.18 27.269)"
                >
                  <g id="Group_4382" data-name="Group 4382">
                    <g id="Group_4381" data-name="Group 4381">
                      <g id="Group_4380" data-name="Group 4380">
                        <rect
                          id="Rectangle_2741"
                          data-name="Rectangle 2741"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4387"
                  data-name="Group 4387"
                  transform="translate(22.724 27.269)"
                >
                  <g id="Group_4386" data-name="Group 4386">
                    <g id="Group_4385" data-name="Group 4385">
                      <g id="Group_4384" data-name="Group 4384">
                        <rect
                          id="Rectangle_2742"
                          data-name="Rectangle 2742"
                          width="2.658"
                          height="2.658"
                          fill="#ebebeb"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4391"
                  data-name="Group 4391"
                  transform="translate(29.267 27.269)"
                >
                  <g id="Group_4390" data-name="Group 4390">
                    <g id="Group_4389" data-name="Group 4389">
                      <g id="Group_4388" data-name="Group 4388">
                        <rect
                          id="Rectangle_2743"
                          data-name="Rectangle 2743"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4395"
                  data-name="Group 4395"
                  transform="translate(35.811 27.269)"
                >
                  <g id="Group_4394" data-name="Group 4394">
                    <g id="Group_4393" data-name="Group 4393">
                      <g id="Group_4392" data-name="Group 4392">
                        <rect
                          id="Rectangle_2744"
                          data-name="Rectangle 2744"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4399"
                  data-name="Group 4399"
                  transform="translate(42.475 27.149)"
                >
                  <g id="Group_4398" data-name="Group 4398">
                    <g id="Group_4397" data-name="Group 4397">
                      <g id="Group_4396" data-name="Group 4396">
                        <rect
                          id="Rectangle_2745"
                          data-name="Rectangle 2745"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4403"
                  data-name="Group 4403"
                  transform="translate(48.898 27.269)"
                >
                  <g id="Group_4402" data-name="Group 4402">
                    <g id="Group_4401" data-name="Group 4401">
                      <g id="Group_4400" data-name="Group 4400">
                        <rect
                          id="Rectangle_2746"
                          data-name="Rectangle 2746"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4407"
                  data-name="Group 4407"
                  transform="translate(9.637 32.921)"
                >
                  <g id="Group_4406" data-name="Group 4406">
                    <g id="Group_4405" data-name="Group 4405">
                      <g id="Group_4404" data-name="Group 4404">
                        <rect
                          id="Rectangle_2747"
                          data-name="Rectangle 2747"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4411"
                  data-name="Group 4411"
                  transform="translate(16.301 32.8)"
                >
                  <g id="Group_4410" data-name="Group 4410">
                    <g id="Group_4409" data-name="Group 4409">
                      <g id="Group_4408" data-name="Group 4408">
                        <rect
                          id="Rectangle_2748"
                          data-name="Rectangle 2748"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4415"
                  data-name="Group 4415"
                  transform="translate(22.724 32.921)"
                >
                  <g id="Group_4414" data-name="Group 4414">
                    <g id="Group_4413" data-name="Group 4413">
                      <g id="Group_4412" data-name="Group 4412">
                        <rect
                          id="Rectangle_2749"
                          data-name="Rectangle 2749"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4419"
                  data-name="Group 4419"
                  transform="translate(29.267 32.921)"
                >
                  <g id="Group_4418" data-name="Group 4418">
                    <g id="Group_4417" data-name="Group 4417">
                      <g id="Group_4416" data-name="Group 4416">
                        <rect
                          id="Rectangle_2750"
                          data-name="Rectangle 2750"
                          width="2.658"
                          height="2.658"
                          fill="#ebebeb"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4423"
                  data-name="Group 4423"
                  transform="translate(35.811 32.921)"
                >
                  <g id="Group_4422" data-name="Group 4422">
                    <g id="Group_4421" data-name="Group 4421">
                      <g id="Group_4420" data-name="Group 4420">
                        <rect
                          id="Rectangle_2751"
                          data-name="Rectangle 2751"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4427"
                  data-name="Group 4427"
                  transform="translate(42.355 32.921)"
                >
                  <g id="Group_4426" data-name="Group 4426">
                    <g id="Group_4425" data-name="Group 4425">
                      <g id="Group_4424" data-name="Group 4424">
                        <rect
                          id="Rectangle_2752"
                          data-name="Rectangle 2752"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4431"
                  data-name="Group 4431"
                  transform="translate(48.898 32.921)"
                >
                  <g id="Group_4430" data-name="Group 4430">
                    <g id="Group_4429" data-name="Group 4429">
                      <g id="Group_4428" data-name="Group 4428">
                        <rect
                          id="Rectangle_2753"
                          data-name="Rectangle 2753"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4435"
                  data-name="Group 4435"
                  transform="translate(9.637 38.572)"
                >
                  <g id="Group_4434" data-name="Group 4434">
                    <g id="Group_4433" data-name="Group 4433">
                      <g id="Group_4432" data-name="Group 4432">
                        <rect
                          id="Rectangle_2754"
                          data-name="Rectangle 2754"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4439"
                  data-name="Group 4439"
                  transform="translate(16.18 38.572)"
                >
                  <g id="Group_4438" data-name="Group 4438">
                    <g id="Group_4437" data-name="Group 4437">
                      <g id="Group_4436" data-name="Group 4436">
                        <rect
                          id="Rectangle_2755"
                          data-name="Rectangle 2755"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4443"
                  data-name="Group 4443"
                  transform="translate(22.724 38.572)"
                >
                  <g id="Group_4442" data-name="Group 4442">
                    <g id="Group_4441" data-name="Group 4441">
                      <g id="Group_4440" data-name="Group 4440">
                        <rect
                          id="Rectangle_2756"
                          data-name="Rectangle 2756"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4447"
                  data-name="Group 4447"
                  transform="translate(29.388 38.452)"
                >
                  <g id="Group_4446" data-name="Group 4446">
                    <g id="Group_4445" data-name="Group 4445">
                      <g id="Group_4444" data-name="Group 4444">
                        <rect
                          id="Rectangle_2757"
                          data-name="Rectangle 2757"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4451"
                  data-name="Group 4451"
                  transform="translate(35.811 38.572)"
                >
                  <g id="Group_4450" data-name="Group 4450">
                    <g id="Group_4449" data-name="Group 4449">
                      <g id="Group_4448" data-name="Group 4448">
                        <rect
                          id="Rectangle_2758"
                          data-name="Rectangle 2758"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4455"
                  data-name="Group 4455"
                  transform="translate(42.355 38.572)"
                >
                  <g id="Group_4454" data-name="Group 4454">
                    <g id="Group_4453" data-name="Group 4453">
                      <g id="Group_4452" data-name="Group 4452">
                        <rect
                          id="Rectangle_2759"
                          data-name="Rectangle 2759"
                          width="2.658"
                          height="2.658"
                          fill="#ebebeb"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4459"
                  data-name="Group 4459"
                  transform="translate(48.898 38.572)"
                >
                  <g id="Group_4458" data-name="Group 4458">
                    <g id="Group_4457" data-name="Group 4457">
                      <g id="Group_4456" data-name="Group 4456">
                        <rect
                          id="Rectangle_2760"
                          data-name="Rectangle 2760"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4463"
                  data-name="Group 4463"
                  transform="translate(9.637 44.224)"
                >
                  <g id="Group_4462" data-name="Group 4462">
                    <g id="Group_4461" data-name="Group 4461">
                      <g id="Group_4460" data-name="Group 4460">
                        <rect
                          id="Rectangle_2761"
                          data-name="Rectangle 2761"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4467"
                  data-name="Group 4467"
                  transform="translate(16.18 44.224)"
                >
                  <g id="Group_4466" data-name="Group 4466">
                    <g id="Group_4465" data-name="Group 4465">
                      <g id="Group_4464" data-name="Group 4464">
                        <rect
                          id="Rectangle_2762"
                          data-name="Rectangle 2762"
                          width="2.658"
                          height="2.658"
                          fill="#ebebeb"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4471"
                  data-name="Group 4471"
                  transform="translate(22.724 44.224)"
                >
                  <g id="Group_4470" data-name="Group 4470">
                    <g id="Group_4469" data-name="Group 4469">
                      <g id="Group_4468" data-name="Group 4468">
                        <rect
                          id="Rectangle_2763"
                          data-name="Rectangle 2763"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4475"
                  data-name="Group 4475"
                  transform="translate(29.267 44.224)"
                >
                  <g id="Group_4474" data-name="Group 4474">
                    <g id="Group_4473" data-name="Group 4473">
                      <g id="Group_4472" data-name="Group 4472">
                        <rect
                          id="Rectangle_2764"
                          data-name="Rectangle 2764"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4479"
                  data-name="Group 4479"
                  transform="translate(35.811 44.224)"
                >
                  <g id="Group_4478" data-name="Group 4478">
                    <g id="Group_4477" data-name="Group 4477">
                      <g id="Group_4476" data-name="Group 4476">
                        <rect
                          id="Rectangle_2765"
                          data-name="Rectangle 2765"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4483"
                  data-name="Group 4483"
                  transform="translate(42.475 44.103)"
                >
                  <g id="Group_4482" data-name="Group 4482">
                    <g id="Group_4481" data-name="Group 4481">
                      <g id="Group_4480" data-name="Group 4480">
                        <rect
                          id="Rectangle_2766"
                          data-name="Rectangle 2766"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4487"
                  data-name="Group 4487"
                  transform="translate(48.898 44.224)"
                >
                  <g id="Group_4486" data-name="Group 4486">
                    <g id="Group_4485" data-name="Group 4485">
                      <g id="Group_4484" data-name="Group 4484">
                        <rect
                          id="Rectangle_2767"
                          data-name="Rectangle 2767"
                          width="2.658"
                          height="2.658"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                id="Group_4592"
                data-name="Group 4592"
                transform="translate(0 110.809)"
              >
                <g id="Group_4579" data-name="Group 4579">
                  <g
                    id="Group_4491"
                    data-name="Group 4491"
                    transform="translate(13.774)"
                  >
                    <g id="Group_4490" data-name="Group 4490">
                      <g id="Group_4489" data-name="Group 4489">
                        <path
                          id="Path_16059"
                          data-name="Path 16059"
                          d="M74.871,317.614a4.708,4.708,0,0,1-2.44-2.433c-.194-.448-.2-1.143.279-1.243.293-.061.56.167.772.377l2.13,2.112a4.475,4.475,0,0,1,.146-3.461c.183-.384.561-.793.959-.646.314.116.414.5.469.833q.255,1.526.511,3.053a7.333,7.333,0,0,1,1.673-3.2c.3-.33.771-.652,1.146-.417.331.208.314.688.244,1.071a15.116,15.116,0,0,1-.8,2.8,5.282,5.282,0,0,1,3.311-1.313,1.169,1.169,0,0,1,.98.317c.33.417.041,1.033-.311,1.432-1.043,1.181-3.492,1.485-5.064,1.382"
                          transform="translate(-72.307 -312.29)"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4494"
                    data-name="Group 4494"
                    transform="translate(2.035 5.188)"
                  >
                    <g id="Group_4493" data-name="Group 4493">
                      <g id="Group_4492" data-name="Group 4492">
                        <path
                          id="Path_16060"
                          data-name="Path 16060"
                          d="M65.825,328.291c-3.815-3-10.519-3.428-14.933-1.408a15.909,15.909,0,0,0-8.734,12.672c-.463,4.832,1.866,9.733,3.847,14.165l19.261.088c2.312-3.818,4.716-8.09,4.875-12.55S69.331,331.051,65.825,328.291Z"
                          transform="translate(-42.098 -325.64)"
                          fill="#ebebeb"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4498"
                    data-name="Group 4498"
                    transform="translate(5.365 5.186)"
                  >
                    <g id="Group_4497" data-name="Group 4497">
                      <g id="Group_4496" data-name="Group 4496">
                        <g id="Group_4495" data-name="Group 4495">
                          <path
                            id="Path_16061"
                            data-name="Path 16061"
                            d="M62.423,325.636a.341.341,0,0,1-.085.026l-.251.059-.41.089a3.767,3.767,0,0,0-.552.145,10.952,10.952,0,0,0-3.263,1.563,14.713,14.713,0,0,0-3.717,3.859,22.189,22.189,0,0,0-1.558,2.775,24.42,24.42,0,0,0-1.2,3.2,14.667,14.667,0,0,0-.325,6.529,28.144,28.144,0,0,0,1.452,5.194c.534,1.444,1.01,2.6,1.325,3.4l.359.926.089.242a.324.324,0,0,1,.025.085.314.314,0,0,1-.042-.078l-.106-.236-.391-.913c-.336-.794-.829-1.941-1.38-3.383a27.465,27.465,0,0,1-1.5-5.212,14.689,14.689,0,0,1,.316-6.607,24.219,24.219,0,0,1,1.21-3.225,22.078,22.078,0,0,1,1.58-2.793,14.626,14.626,0,0,1,3.782-3.871,10.625,10.625,0,0,1,3.317-1.526,3.554,3.554,0,0,1,.559-.129l.415-.073.255-.041A.321.321,0,0,1,62.423,325.636Z"
                            transform="translate(-50.667 -325.635)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4502"
                    data-name="Group 4502"
                    transform="translate(21.136 5.71)"
                  >
                    <g id="Group_4501" data-name="Group 4501">
                      <g id="Group_4500" data-name="Group 4500">
                        <g id="Group_4499" data-name="Group 4499">
                          <path
                            id="Path_16062"
                            data-name="Path 16062"
                            d="M92.848,354.477a1.874,1.874,0,0,1,.089-.288l.288-.813c.253-.705.623-1.724,1.054-2.991s.917-2.786,1.339-4.5a29.516,29.516,0,0,0,.856-5.67,19.733,19.733,0,0,0-.588-5.685,15.546,15.546,0,0,0-1.809-4.3,12.608,12.608,0,0,0-1.969-2.459c-.257-.272-.494-.442-.636-.579a1.878,1.878,0,0,1-.219-.207,1.847,1.847,0,0,1,.242.179,8.191,8.191,0,0,1,.661.556,11.975,11.975,0,0,1,2.029,2.443,15.335,15.335,0,0,1,1.862,4.325,19.562,19.562,0,0,1,.608,5.735,28.9,28.9,0,0,1-.876,5.7c-.432,1.722-.933,3.24-1.38,4.5s-.836,2.276-1.109,2.974l-.319.8A1.858,1.858,0,0,1,92.848,354.477Z"
                            transform="translate(-91.252 -326.982)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4506"
                    data-name="Group 4506"
                    transform="translate(14.797 5.3)"
                  >
                    <g id="Group_4505" data-name="Group 4505">
                      <g id="Group_4504" data-name="Group 4504">
                        <g id="Group_4503" data-name="Group 4503">
                          <path
                            id="Path_16063"
                            data-name="Path 16063"
                            d="M79.153,325.927a1.8,1.8,0,0,1-.076.283l-.25.8c-.113.345-.246.768-.391,1.263s-.323,1.054-.492,1.68c-.36,1.246-.738,2.744-1.12,4.415s-.727,3.526-1.021,5.482-.473,3.835-.592,5.545c-.042.856-.1,1.669-.106,2.432q-.013.571-.024,1.1t.006,1.018c-.005.649.025,1.235.043,1.749s.038.958.065,1.32.037.627.05.834a1.735,1.735,0,0,1,0,.292,1.747,1.747,0,0,1-.041-.289q-.031-.31-.084-.832c-.038-.361-.074-.8-.1-1.32s-.066-1.1-.07-1.753q-.009-.488-.018-1.02c0-.355.009-.724.014-1.106,0-.765.052-1.58.09-2.439.11-1.715.295-3.6.58-5.561s.659-3.817,1.037-5.493.784-3.17,1.16-4.414c.177-.625.362-1.183.519-1.674s.3-.913.421-1.255l.282-.787A1.763,1.763,0,0,1,79.153,325.927Z"
                            transform="translate(-74.939 -325.927)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4510"
                    data-name="Group 4510"
                    transform="translate(0 20.635)"
                  >
                    <g id="Group_4509" data-name="Group 4509">
                      <g id="Group_4508" data-name="Group 4508">
                        <g id="Group_4507" data-name="Group 4507">
                          <path
                            id="Path_16064"
                            data-name="Path 16064"
                            d="M39.57,365.394a6.165,6.165,0,0,1-1.316.7,6.184,6.184,0,0,1-1.391.534,6.168,6.168,0,0,1,1.316-.7A6.177,6.177,0,0,1,39.57,365.394Z"
                            transform="translate(-36.862 -365.389)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4514"
                    data-name="Group 4514"
                    transform="translate(0.518 13.481)"
                  >
                    <g id="Group_4513" data-name="Group 4513">
                      <g id="Group_4512" data-name="Group 4512">
                        <g id="Group_4511" data-name="Group 4511">
                          <path
                            id="Path_16065"
                            data-name="Path 16065"
                            d="M41,348.6a7.3,7.3,0,0,1-1.446-.731,7.306,7.306,0,0,1-1.355-.889,7.3,7.3,0,0,1,1.446.731A7.279,7.279,0,0,1,41,348.6Z"
                            transform="translate(-38.195 -346.981)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4518"
                    data-name="Group 4518"
                    transform="translate(5.718 8.192)"
                  >
                    <g id="Group_4517" data-name="Group 4517">
                      <g id="Group_4516" data-name="Group 4516">
                        <g id="Group_4515" data-name="Group 4515">
                          <path
                            id="Path_16066"
                            data-name="Path 16066"
                            d="M52.692,335.712a9.254,9.254,0,0,1-1.11-2.34,9.305,9.305,0,0,1,1.11,2.34Z"
                            transform="translate(-51.575 -333.371)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4522"
                    data-name="Group 4522"
                    transform="translate(10.406 4.528)"
                  >
                    <g id="Group_4521" data-name="Group 4521">
                      <g id="Group_4520" data-name="Group 4520">
                        <g id="Group_4519" data-name="Group 4519">
                          <path
                            id="Path_16067"
                            data-name="Path 16067"
                            d="M64.9,325.631a6.148,6.148,0,0,1-1.253-1.687,6.132,6.132,0,0,1,1.253,1.687Z"
                            transform="translate(-63.639 -323.942)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4526"
                    data-name="Group 4526"
                    transform="translate(2.107 27.395)"
                  >
                    <g id="Group_4525" data-name="Group 4525">
                      <g id="Group_4524" data-name="Group 4524">
                        <g id="Group_4523" data-name="Group 4523">
                          <path
                            id="Path_16068"
                            data-name="Path 16068"
                            d="M45.068,382.79a6.951,6.951,0,0,1-1.348.833,6.964,6.964,0,0,1-1.436.673,7.015,7.015,0,0,1,1.349-.833A7.015,7.015,0,0,1,45.068,382.79Z"
                            transform="translate(-42.283 -382.786)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4530"
                    data-name="Group 4530"
                    transform="translate(8.268 22.698)"
                  >
                    <g id="Group_4529" data-name="Group 4529">
                      <g id="Group_4528" data-name="Group 4528">
                        <g id="Group_4527" data-name="Group 4527">
                          <path
                            id="Path_16069"
                            data-name="Path 16069"
                            d="M60.513,372.034A10.249,10.249,0,0,1,58.14,370.7a5.163,5.163,0,0,1,1.231.586A5.183,5.183,0,0,1,60.513,372.034Z"
                            transform="translate(-58.139 -370.699)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4534"
                    data-name="Group 4534"
                    transform="translate(9.759 16.337)"
                  >
                    <g id="Group_4533" data-name="Group 4533">
                      <g id="Group_4532" data-name="Group 4532">
                        <g id="Group_4531" data-name="Group 4531">
                          <path
                            id="Path_16070"
                            data-name="Path 16070"
                            d="M64.462,354.335a5.716,5.716,0,0,1-2.487.97,7.89,7.89,0,0,1,1.235-.507A7.833,7.833,0,0,1,64.462,354.335Z"
                            transform="translate(-61.975 -354.33)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4538"
                    data-name="Group 4538"
                    transform="translate(13.368 8.556)"
                  >
                    <g id="Group_4537" data-name="Group 4537">
                      <g id="Group_4536" data-name="Group 4536">
                        <g id="Group_4535" data-name="Group 4535">
                          <path
                            id="Path_16071"
                            data-name="Path 16071"
                            d="M71.967,336.294a3.452,3.452,0,0,1-.689-1.988,32.027,32.027,0,0,1,.689,1.988Z"
                            transform="translate(-71.261 -334.307)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4542"
                    data-name="Group 4542"
                    transform="translate(9.986 29.072)"
                  >
                    <g id="Group_4541" data-name="Group 4541">
                      <g id="Group_4540" data-name="Group 4540">
                        <g id="Group_4539" data-name="Group 4539">
                          <path
                            id="Path_16072"
                            data-name="Path 16072"
                            d="M62.564,389.611a10.7,10.7,0,0,1,1.2-2.509,10.705,10.705,0,0,1-1.2,2.509Z"
                            transform="translate(-62.559 -387.101)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4546"
                    data-name="Group 4546"
                    transform="translate(17.752 27.242)"
                  >
                    <g id="Group_4545" data-name="Group 4545">
                      <g id="Group_4544" data-name="Group 4544">
                        <g id="Group_4543" data-name="Group 4543">
                          <path
                            id="Path_16073"
                            data-name="Path 16073"
                            d="M84.491,384.667a5.708,5.708,0,0,1-1.945-2.273c.045-.028.423.525.959,1.149S84.525,384.627,84.491,384.667Z"
                            transform="translate(-82.542 -382.392)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4550"
                    data-name="Group 4550"
                    transform="translate(20.288 21.045)"
                  >
                    <g id="Group_4549" data-name="Group 4549">
                      <g id="Group_4548" data-name="Group 4548">
                        <g id="Group_4547" data-name="Group 4547">
                          <path
                            id="Path_16074"
                            data-name="Path 16074"
                            d="M91.846,366.45a14.128,14.128,0,0,1-2.776,1.591,14.159,14.159,0,0,1,2.776-1.591Z"
                            transform="translate(-89.069 -366.446)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4554"
                    data-name="Group 4554"
                    transform="translate(20.8 13.755)"
                  >
                    <g id="Group_4553" data-name="Group 4553">
                      <g id="Group_4552" data-name="Group 4552">
                        <g id="Group_4551" data-name="Group 4551">
                          <path
                            id="Path_16075"
                            data-name="Path 16075"
                            d="M90.387,349.771a12.684,12.684,0,0,1,2.206-2.082,12.721,12.721,0,0,1-2.206,2.082Z"
                            transform="translate(-90.385 -347.687)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4558"
                    data-name="Group 4558"
                    transform="translate(18.892 8.677)"
                  >
                    <g id="Group_4557" data-name="Group 4557">
                      <g id="Group_4556" data-name="Group 4556">
                        <g id="Group_4555" data-name="Group 4555">
                          <path
                            id="Path_16076"
                            data-name="Path 16076"
                            d="M87.488,336.254a9.281,9.281,0,0,1-2.01-1.632,9.309,9.309,0,0,1,2.01,1.632Z"
                            transform="translate(-85.477 -334.618)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4562"
                    data-name="Group 4562"
                    transform="translate(25.113 6.652)"
                  >
                    <g id="Group_4561" data-name="Group 4561">
                      <g id="Group_4560" data-name="Group 4560">
                        <g id="Group_4559" data-name="Group 4559">
                          <path
                            id="Path_16077"
                            data-name="Path 16077"
                            d="M103.7,329.412a9.64,9.64,0,0,1-2.209,1.439,9.608,9.608,0,0,1,2.209-1.439Z"
                            transform="translate(-101.485 -329.408)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4566"
                    data-name="Group 4566"
                    transform="translate(27.581 11.681)"
                  >
                    <g
                      id="Group_4565"
                      data-name="Group 4565"
                      transform="translate(0)"
                    >
                      <g id="Group_4564" data-name="Group 4564">
                        <g id="Group_4563" data-name="Group 4563">
                          <path
                            id="Path_16078"
                            data-name="Path 16078"
                            d="M110.051,342.39a6.829,6.829,0,0,1-2.214.157,6.831,6.831,0,0,1,2.214-.157Z"
                            transform="translate(-107.837 -342.349)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4570"
                    data-name="Group 4570"
                    transform="translate(28.621 17.415)"
                  >
                    <g id="Group_4569" data-name="Group 4569">
                      <g id="Group_4568" data-name="Group 4568">
                        <g id="Group_4567" data-name="Group 4567">
                          <path
                            id="Path_16079"
                            data-name="Path 16079"
                            d="M113.3,357.4a10.858,10.858,0,0,1-2.789-.269,10.854,10.854,0,0,1,2.789.269Z"
                            transform="translate(-110.513 -357.102)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4574"
                    data-name="Group 4574"
                    transform="translate(28.156 22.955)"
                  >
                    <g id="Group_4573" data-name="Group 4573">
                      <g id="Group_4572" data-name="Group 4572">
                        <g id="Group_4571" data-name="Group 4571">
                          <path
                            id="Path_16080"
                            data-name="Path 16080"
                            d="M111.77,373.839a16.8,16.8,0,0,1-2.452-2.479,16.8,16.8,0,0,1,2.452,2.479Z"
                            transform="translate(-109.317 -371.359)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4578"
                    data-name="Group 4578"
                    transform="translate(26.191 28.615)"
                  >
                    <g
                      id="Group_4577"
                      data-name="Group 4577"
                      transform="translate(0)"
                    >
                      <g id="Group_4576" data-name="Group 4576">
                        <g id="Group_4575" data-name="Group 4575">
                          <path
                            id="Path_16081"
                            data-name="Path 16081"
                            d="M106.572,388.694a8.5,8.5,0,0,1-2.31-2.768c.044-.028.509.631,1.146,1.391S106.608,388.656,106.572,388.694Z"
                            transform="translate(-104.259 -385.926)"
                            fill="#e0e0e0"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4591"
                  data-name="Group 4591"
                  transform="translate(0.203 32.971)"
                >
                  <g id="Group_4590" data-name="Group 4590">
                    <g
                      id="Group_4582"
                      data-name="Group 4582"
                      transform="translate(0.249)"
                    >
                      <g id="Group_4581" data-name="Group 4581">
                        <g id="Group_4580" data-name="Group 4580">
                          <rect
                            id="Rectangle_2768"
                            data-name="Rectangle 2768"
                            width="30.773"
                            height="5.454"
                            fill="#ebebeb"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4585"
                      data-name="Group 4585"
                      transform="translate(2.773 4.053)"
                    >
                      <g id="Group_4584" data-name="Group 4584">
                        <g id="Group_4583" data-name="Group 4583">
                          <path
                            id="Path_16082"
                            data-name="Path 16082"
                            d="M44.52,407.564l3.742,16.3H66.6l4.094-16.3Z"
                            transform="translate(-44.52 -407.564)"
                            fill="#ebebeb"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4589"
                      data-name="Group 4589"
                      transform="translate(0 5.353)"
                    >
                      <g id="Group_4588" data-name="Group 4588">
                        <g id="Group_4587" data-name="Group 4587">
                          <g id="Group_4586" data-name="Group 4586">
                            <path
                              id="Path_16083"
                              data-name="Path 16083"
                              d="M68.388,411.017c0,.06-6.941.108-15.5.108s-15.5-.048-15.5-.108,6.94-.108,15.5-.108S68.388,410.958,68.388,411.017Z"
                              transform="translate(-37.383 -410.909)"
                              fill="#e0e0e0"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="Character" transform="translate(-422.65 6928.411)">
              <g
                id="Group_4927"
                data-name="Group 4927"
                transform="translate(0 0)"
              >
                <g
                  id="Group_4801"
                  data-name="Group 4801"
                  transform="translate(17.707)"
                >
                  <g id="Group_4594" data-name="Group 4594">
                    <g id="Group_4593" data-name="Group 4593">
                      <path
                        id="Path_16084"
                        data-name="Path 16084"
                        d="M233.164,163.879a19.563,19.563,0,0,0-3.926-10.111c-1.085-1.49-2.365-2.94-2.752-4.742-.515-2.4.624-5.16-.687-7.237-.924-1.465-2.793-2.073-3.846-3.448-1.13-1.477-1.1-3.515-1.772-5.25s-2.921-3.225-4.3-1.976c-.267-3.267.264-5.1-2.525-6.821s-8.28-.89-9.349,2.208c-2.368-1.984-6.7-3.891-9.424-2.433-1.679.9-2.969,2.377-4.528,3.471-2.421,1.7-5.381,2.4-8.088,3.592s-5.387,3.173-6.014,6.063c-.462,2.132.283,4.376-.112,6.522-.333,1.807-1.436,3.358-2.285,4.986a19.006,19.006,0,0,0-1.615,4.3c-.706,2.916-.315,6.674,2.408,7.936a4.343,4.343,0,0,0,.869,8.51l-4.581,8.3a3.992,3.992,0,0,0-.72,2.486,2.718,2.718,0,0,0,2.732,1.982,7.931,7.931,0,0,0,3.47-1.074,4.411,4.411,0,0,0,7.878-.209,5.413,5.413,0,0,0,9.49.049L212.1,176.73l14.03-1.3c2.032-.188,4.306-.5,5.55-2.121a7.5,7.5,0,0,0,1.155-3.763A31.088,31.088,0,0,0,233.164,163.879Z"
                        transform="translate(-169.888 -123.413)"
                        fill="#263238"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4785"
                    data-name="Group 4785"
                    transform="translate(11.93 11.295)"
                  >
                    <g id="Group_4602" data-name="Group 4602">
                      <g id="Group_4601" data-name="Group 4601">
                        <g id="Group_4600" data-name="Group 4600">
                          <g id="Group_4599" data-name="Group 4599">
                            <g id="Group_4598" data-name="Group 4598">
                              <g id="Group_4597" data-name="Group 4597">
                                <g id="Group_4596" data-name="Group 4596">
                                  <g id="Group_4595" data-name="Group 4595">
                                    <path
                                      id="Path_16085"
                                      data-name="Path 16085"
                                      d="M219.447,233.112l-8.98-23.826,4.673-4.676-.185-1.5c-.507-3.75-.7-5.29-.694-5.255,0,0-8.083-.338-11-10.47-1.449-5.039-2.23-13.5-2.645-20.438-.373-6.248,2.8-14.361,9.055-14.469l19.89,2.5a3.663,3.663,0,0,1,3.706,3.286l3.438,41.811,2.637,2.254,3.178,28.964Z"
                                      transform="translate(-200.588 -152.479)"
                                      fill="#b47266"
                                    />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4750"
                      data-name="Group 4750"
                      transform="translate(2.146 11.448)"
                    >
                      <g id="Group_4749" data-name="Group 4749">
                        <g id="Group_4748" data-name="Group 4748">
                          <g id="Group_4747" data-name="Group 4747">
                            <g id="Group_4746" data-name="Group 4746">
                              <g
                                id="Group_4715"
                                data-name="Group 4715"
                                transform="translate(0.223 4.968)"
                              >
                                <g id="Group_4714" data-name="Group 4714">
                                  <g id="Group_4713" data-name="Group 4713">
                                    <g
                                      id="Group_4649"
                                      data-name="Group 4649"
                                      transform="translate(0 1.166)"
                                    >
                                      <g
                                        id="Group_4617"
                                        data-name="Group 4617"
                                        transform="translate(2.218 3.589)"
                                      >
                                        <g
                                          id="Group_4616"
                                          data-name="Group 4616"
                                        >
                                          <g
                                            id="Group_4615"
                                            data-name="Group 4615"
                                          >
                                            <g
                                              id="Group_4614"
                                              data-name="Group 4614"
                                            >
                                              <g
                                                id="Group_4613"
                                                data-name="Group 4613"
                                              >
                                                <g
                                                  id="Group_4612"
                                                  data-name="Group 4612"
                                                >
                                                  <g
                                                    id="Group_4611"
                                                    data-name="Group 4611"
                                                  >
                                                    <g
                                                      id="Group_4610"
                                                      data-name="Group 4610"
                                                    >
                                                      <g
                                                        id="Group_4609"
                                                        data-name="Group 4609"
                                                      >
                                                        <g
                                                          id="Group_4608"
                                                          data-name="Group 4608"
                                                        >
                                                          <g
                                                            id="Group_4607"
                                                            data-name="Group 4607"
                                                          >
                                                            <g
                                                              id="Group_4606"
                                                              data-name="Group 4606"
                                                            >
                                                              <g
                                                                id="Group_4605"
                                                                data-name="Group 4605"
                                                              >
                                                                <g
                                                                  id="Group_4604"
                                                                  data-name="Group 4604"
                                                                >
                                                                  <g
                                                                    id="Group_4603"
                                                                    data-name="Group 4603"
                                                                  >
                                                                    <path
                                                                      id="Path_16086"
                                                                      data-name="Path 16086"
                                                                      d="M212.395,208.327a1.335,1.335,0,0,0,1.443,1.179,1.277,1.277,0,0,0,1.219-1.363,1.336,1.336,0,0,0-1.441-1.181A1.278,1.278,0,0,0,212.395,208.327Z"
                                                                      transform="translate(-212.39 -206.959)"
                                                                      fill="#263238"
                                                                    />
                                                                  </g>
                                                                </g>
                                                              </g>
                                                            </g>
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                      <g
                                        id="Group_4632"
                                        data-name="Group 4632"
                                        transform="translate(15.467 2.461)"
                                      >
                                        <g
                                          id="Group_4631"
                                          data-name="Group 4631"
                                        >
                                          <g
                                            id="Group_4630"
                                            data-name="Group 4630"
                                          >
                                            <g
                                              id="Group_4629"
                                              data-name="Group 4629"
                                            >
                                              <g
                                                id="Group_4628"
                                                data-name="Group 4628"
                                              >
                                                <g
                                                  id="Group_4627"
                                                  data-name="Group 4627"
                                                >
                                                  <g
                                                    id="Group_4626"
                                                    data-name="Group 4626"
                                                  >
                                                    <g
                                                      id="Group_4625"
                                                      data-name="Group 4625"
                                                    >
                                                      <g
                                                        id="Group_4624"
                                                        data-name="Group 4624"
                                                      >
                                                        <g
                                                          id="Group_4623"
                                                          data-name="Group 4623"
                                                        >
                                                          <g
                                                            id="Group_4622"
                                                            data-name="Group 4622"
                                                          >
                                                            <g
                                                              id="Group_4621"
                                                              data-name="Group 4621"
                                                            >
                                                              <g
                                                                id="Group_4620"
                                                                data-name="Group 4620"
                                                              >
                                                                <g
                                                                  id="Group_4619"
                                                                  data-name="Group 4619"
                                                                >
                                                                  <g
                                                                    id="Group_4618"
                                                                    data-name="Group 4618"
                                                                  >
                                                                    <path
                                                                      id="Path_16087"
                                                                      data-name="Path 16087"
                                                                      d="M246.488,205.424a1.336,1.336,0,0,0,1.443,1.18,1.278,1.278,0,0,0,1.219-1.363,1.336,1.336,0,0,0-1.441-1.181A1.278,1.278,0,0,0,246.488,205.424Z"
                                                                      transform="translate(-246.483 -204.056)"
                                                                      fill="#263238"
                                                                    />
                                                                  </g>
                                                                </g>
                                                              </g>
                                                            </g>
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                      <g id="Group_4648" data-name="Group 4648">
                                        <g
                                          id="Group_4647"
                                          data-name="Group 4647"
                                        >
                                          <g
                                            id="Group_4646"
                                            data-name="Group 4646"
                                          >
                                            <g
                                              id="Group_4645"
                                              data-name="Group 4645"
                                            >
                                              <g
                                                id="Group_4644"
                                                data-name="Group 4644"
                                              >
                                                <g
                                                  id="Group_4643"
                                                  data-name="Group 4643"
                                                >
                                                  <g
                                                    id="Group_4642"
                                                    data-name="Group 4642"
                                                  >
                                                    <g
                                                      id="Group_4641"
                                                      data-name="Group 4641"
                                                    >
                                                      <g
                                                        id="Group_4640"
                                                        data-name="Group 4640"
                                                      >
                                                        <g
                                                          id="Group_4639"
                                                          data-name="Group 4639"
                                                        >
                                                          <g
                                                            id="Group_4638"
                                                            data-name="Group 4638"
                                                          >
                                                            <g
                                                              id="Group_4637"
                                                              data-name="Group 4637"
                                                            >
                                                              <g
                                                                id="Group_4636"
                                                                data-name="Group 4636"
                                                              >
                                                                <g
                                                                  id="Group_4635"
                                                                  data-name="Group 4635"
                                                                >
                                                                  <g
                                                                    id="Group_4634"
                                                                    data-name="Group 4634"
                                                                  >
                                                                    <g
                                                                      id="Group_4633"
                                                                      data-name="Group 4633"
                                                                    >
                                                                      <path
                                                                        id="Path_16088"
                                                                        data-name="Path 16088"
                                                                        d="M206.712,199.464c.185.153,1.1-.714,2.525-.886,1.423-.192,2.56.412,2.693.219.066-.087-.14-.378-.636-.654a3.664,3.664,0,0,0-2.182-.389,3.519,3.519,0,0,0-1.983.921C206.732,199.065,206.622,199.4,206.712,199.464Z"
                                                                        transform="translate(-206.683 -197.724)"
                                                                        fill="#263238"
                                                                      />
                                                                    </g>
                                                                  </g>
                                                                </g>
                                                              </g>
                                                            </g>
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                    <g
                                      id="Group_4666"
                                      data-name="Group 4666"
                                      transform="translate(14.172)"
                                    >
                                      <g id="Group_4665" data-name="Group 4665">
                                        <g
                                          id="Group_4664"
                                          data-name="Group 4664"
                                        >
                                          <g
                                            id="Group_4663"
                                            data-name="Group 4663"
                                          >
                                            <g
                                              id="Group_4662"
                                              data-name="Group 4662"
                                            >
                                              <g
                                                id="Group_4661"
                                                data-name="Group 4661"
                                              >
                                                <g
                                                  id="Group_4660"
                                                  data-name="Group 4660"
                                                >
                                                  <g
                                                    id="Group_4659"
                                                    data-name="Group 4659"
                                                  >
                                                    <g
                                                      id="Group_4658"
                                                      data-name="Group 4658"
                                                    >
                                                      <g
                                                        id="Group_4657"
                                                        data-name="Group 4657"
                                                      >
                                                        <g
                                                          id="Group_4656"
                                                          data-name="Group 4656"
                                                        >
                                                          <g
                                                            id="Group_4655"
                                                            data-name="Group 4655"
                                                          >
                                                            <g
                                                              id="Group_4654"
                                                              data-name="Group 4654"
                                                            >
                                                              <g
                                                                id="Group_4653"
                                                                data-name="Group 4653"
                                                              >
                                                                <g
                                                                  id="Group_4652"
                                                                  data-name="Group 4652"
                                                                >
                                                                  <g
                                                                    id="Group_4651"
                                                                    data-name="Group 4651"
                                                                  >
                                                                    <g
                                                                      id="Group_4650"
                                                                      data-name="Group 4650"
                                                                    >
                                                                      <path
                                                                        id="Path_16089"
                                                                        data-name="Path 16089"
                                                                        d="M243.182,196.464c.186.152,1.1-.715,2.526-.886,1.422-.192,2.56.412,2.693.219.066-.087-.138-.378-.636-.654a3.661,3.661,0,0,0-2.182-.389,3.524,3.524,0,0,0-1.983.921C243.2,196.065,243.092,196.4,243.182,196.464Z"
                                                                        transform="translate(-243.153 -194.724)"
                                                                        fill="#263238"
                                                                      />
                                                                    </g>
                                                                  </g>
                                                                </g>
                                                              </g>
                                                            </g>
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                    <g
                                      id="Group_4682"
                                      data-name="Group 4682"
                                      transform="translate(6.437 0)"
                                    >
                                      <g id="Group_4681" data-name="Group 4681">
                                        <g
                                          id="Group_4680"
                                          data-name="Group 4680"
                                        >
                                          <g
                                            id="Group_4679"
                                            data-name="Group 4679"
                                          >
                                            <g
                                              id="Group_4678"
                                              data-name="Group 4678"
                                            >
                                              <g
                                                id="Group_4677"
                                                data-name="Group 4677"
                                              >
                                                <g
                                                  id="Group_4676"
                                                  data-name="Group 4676"
                                                >
                                                  <g
                                                    id="Group_4675"
                                                    data-name="Group 4675"
                                                  >
                                                    <g
                                                      id="Group_4674"
                                                      data-name="Group 4674"
                                                    >
                                                      <g
                                                        id="Group_4673"
                                                        data-name="Group 4673"
                                                      >
                                                        <g
                                                          id="Group_4672"
                                                          data-name="Group 4672"
                                                        >
                                                          <g
                                                            id="Group_4671"
                                                            data-name="Group 4671"
                                                          >
                                                            <g
                                                              id="Group_4670"
                                                              data-name="Group 4670"
                                                            >
                                                              <g
                                                                id="Group_4669"
                                                                data-name="Group 4669"
                                                              >
                                                                <g
                                                                  id="Group_4668"
                                                                  data-name="Group 4668"
                                                                >
                                                                  <g
                                                                    id="Group_4667"
                                                                    data-name="Group 4667"
                                                                  >
                                                                    <path
                                                                      id="Path_16090"
                                                                      data-name="Path 16090"
                                                                      d="M227.019,206.687a9.543,9.543,0,0,0-2.368-.132c-.369.007-.722-.023-.814-.264a1.864,1.864,0,0,1,.11-1.109q.351-1.385.735-2.906c1.009-4.132,1.692-7.512,1.525-7.551s-1.12,3.279-2.129,7.411q-.359,1.527-.687,2.917a2.121,2.121,0,0,0-.013,1.453.921.921,0,0,0,.665.459,2.5,2.5,0,0,0,.629.01A9.321,9.321,0,0,0,227.019,206.687Z"
                                                                      transform="translate(-223.247 -194.724)"
                                                                      fill="#263238"
                                                                    />
                                                                  </g>
                                                                </g>
                                                              </g>
                                                            </g>
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                    <g
                                      id="Group_4697"
                                      data-name="Group 4697"
                                      transform="translate(11.304 23.563)"
                                    >
                                      <g id="Group_4696" data-name="Group 4696">
                                        <g
                                          id="Group_4695"
                                          data-name="Group 4695"
                                        >
                                          <g
                                            id="Group_4694"
                                            data-name="Group 4694"
                                          >
                                            <g
                                              id="Group_4693"
                                              data-name="Group 4693"
                                            >
                                              <g
                                                id="Group_4692"
                                                data-name="Group 4692"
                                              >
                                                <g
                                                  id="Group_4691"
                                                  data-name="Group 4691"
                                                >
                                                  <g
                                                    id="Group_4690"
                                                    data-name="Group 4690"
                                                  >
                                                    <g
                                                      id="Group_4689"
                                                      data-name="Group 4689"
                                                    >
                                                      <g
                                                        id="Group_4688"
                                                        data-name="Group 4688"
                                                      >
                                                        <g
                                                          id="Group_4687"
                                                          data-name="Group 4687"
                                                        >
                                                          <g
                                                            id="Group_4686"
                                                            data-name="Group 4686"
                                                          >
                                                            <g
                                                              id="Group_4685"
                                                              data-name="Group 4685"
                                                            >
                                                              <g
                                                                id="Group_4684"
                                                                data-name="Group 4684"
                                                              >
                                                                <g
                                                                  id="Group_4683"
                                                                  data-name="Group 4683"
                                                                >
                                                                  <path
                                                                    id="Path_16091"
                                                                    data-name="Path 16091"
                                                                    d="M235.771,260.757a26.487,26.487,0,0,0,13.385-5.4s-2.591,7.633-13.053,7.941Z"
                                                                    transform="translate(-235.771 -255.359)"
                                                                    fill="#89544c"
                                                                  />
                                                                </g>
                                                              </g>
                                                            </g>
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                    <g
                                      id="Group_4712"
                                      data-name="Group 4712"
                                      transform="translate(10.552 13.144)"
                                    >
                                      <g id="Group_4711" data-name="Group 4711">
                                        <g
                                          id="Group_4710"
                                          data-name="Group 4710"
                                        >
                                          <g
                                            id="Group_4709"
                                            data-name="Group 4709"
                                          >
                                            <g
                                              id="Group_4708"
                                              data-name="Group 4708"
                                            >
                                              <g
                                                id="Group_4707"
                                                data-name="Group 4707"
                                              >
                                                <g
                                                  id="Group_4706"
                                                  data-name="Group 4706"
                                                >
                                                  <g
                                                    id="Group_4705"
                                                    data-name="Group 4705"
                                                  >
                                                    <g
                                                      id="Group_4704"
                                                      data-name="Group 4704"
                                                    >
                                                      <g
                                                        id="Group_4703"
                                                        data-name="Group 4703"
                                                      >
                                                        <g
                                                          id="Group_4702"
                                                          data-name="Group 4702"
                                                        >
                                                          <g
                                                            id="Group_4701"
                                                            data-name="Group 4701"
                                                          >
                                                            <g
                                                              id="Group_4700"
                                                              data-name="Group 4700"
                                                            >
                                                              <g
                                                                id="Group_4699"
                                                                data-name="Group 4699"
                                                              >
                                                                <g
                                                                  id="Group_4698"
                                                                  data-name="Group 4698"
                                                                >
                                                                  <path
                                                                    id="Path_16092"
                                                                    data-name="Path 16092"
                                                                    d="M233.994,231.031a11.925,11.925,0,0,1,3.632-2.459c.741-.184.666.692,1.157,1.306a2.3,2.3,0,0,1,.243,2.374,2.524,2.524,0,0,1-2.2,1.521c-.844-.094-1.637-.934-2.344-1.419a1.656,1.656,0,0,1-.524-.489.761.761,0,0,1-.03-.751"
                                                                    transform="translate(-233.837 -228.547)"
                                                                    fill="#89544c"
                                                                  />
                                                                </g>
                                                              </g>
                                                            </g>
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <g
                                id="Group_4730"
                                data-name="Group 4730"
                                transform="translate(12.886)"
                              >
                                <g id="Group_4729" data-name="Group 4729">
                                  <g id="Group_4728" data-name="Group 4728">
                                    <g id="Group_4727" data-name="Group 4727">
                                      <g id="Group_4726" data-name="Group 4726">
                                        <g
                                          id="Group_4725"
                                          data-name="Group 4725"
                                        >
                                          <g
                                            id="Group_4724"
                                            data-name="Group 4724"
                                          >
                                            <g
                                              id="Group_4723"
                                              data-name="Group 4723"
                                            >
                                              <g
                                                id="Group_4722"
                                                data-name="Group 4722"
                                              >
                                                <g
                                                  id="Group_4721"
                                                  data-name="Group 4721"
                                                >
                                                  <g
                                                    id="Group_4720"
                                                    data-name="Group 4720"
                                                  >
                                                    <g
                                                      id="Group_4719"
                                                      data-name="Group 4719"
                                                    >
                                                      <g
                                                        id="Group_4718"
                                                        data-name="Group 4718"
                                                      >
                                                        <g
                                                          id="Group_4717"
                                                          data-name="Group 4717"
                                                        >
                                                          <g
                                                            id="Group_4716"
                                                            data-name="Group 4716"
                                                          >
                                                            <path
                                                              id="Path_16093"
                                                              data-name="Path 16093"
                                                              d="M239.283,183.392c.188.37,1.59.011,3.288.007,1.7-.039,3.108.285,3.287-.091.078-.179-.2-.514-.794-.823a5.717,5.717,0,0,0-5.009.064C239.471,182.872,239.2,183.215,239.283,183.392Z"
                                                              transform="translate(-239.268 -181.939)"
                                                              fill="#263238"
                                                            />
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <g
                                id="Group_4745"
                                data-name="Group 4745"
                                transform="translate(0 1.065)"
                              >
                                <g id="Group_4744" data-name="Group 4744">
                                  <g id="Group_4743" data-name="Group 4743">
                                    <g id="Group_4742" data-name="Group 4742">
                                      <g id="Group_4741" data-name="Group 4741">
                                        <g
                                          id="Group_4740"
                                          data-name="Group 4740"
                                        >
                                          <g
                                            id="Group_4739"
                                            data-name="Group 4739"
                                          >
                                            <g
                                              id="Group_4738"
                                              data-name="Group 4738"
                                            >
                                              <g
                                                id="Group_4737"
                                                data-name="Group 4737"
                                              >
                                                <g
                                                  id="Group_4736"
                                                  data-name="Group 4736"
                                                >
                                                  <g
                                                    id="Group_4735"
                                                    data-name="Group 4735"
                                                  >
                                                    <g
                                                      id="Group_4734"
                                                      data-name="Group 4734"
                                                    >
                                                      <g
                                                        id="Group_4733"
                                                        data-name="Group 4733"
                                                      >
                                                        <g
                                                          id="Group_4732"
                                                          data-name="Group 4732"
                                                        >
                                                          <g
                                                            id="Group_4731"
                                                            data-name="Group 4731"
                                                          >
                                                            <path
                                                              id="Path_16094"
                                                              data-name="Path 16094"
                                                              d="M206.165,186.491c.291.293,1.232-.164,2.411-.326,1.174-.2,2.208-.051,2.4-.419.081-.177-.117-.482-.591-.735a3.523,3.523,0,0,0-3.874.6C206.13,186,206.034,186.347,206.165,186.491Z"
                                                              transform="translate(-206.11 -184.681)"
                                                              fill="#263238"
                                                            />
                                                          </g>
                                                        </g>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4763"
                      data-name="Group 4763"
                      transform="translate(31.538 18.097)"
                    >
                      <g id="Group_4762" data-name="Group 4762">
                        <g id="Group_4761" data-name="Group 4761">
                          <g id="Group_4760" data-name="Group 4760">
                            <g id="Group_4759" data-name="Group 4759">
                              <g id="Group_4758" data-name="Group 4758">
                                <g id="Group_4757" data-name="Group 4757">
                                  <g id="Group_4756" data-name="Group 4756">
                                    <g id="Group_4755" data-name="Group 4755">
                                      <g id="Group_4754" data-name="Group 4754">
                                        <g
                                          id="Group_4753"
                                          data-name="Group 4753"
                                        >
                                          <g
                                            id="Group_4752"
                                            data-name="Group 4752"
                                          >
                                            <g
                                              id="Group_4751"
                                              data-name="Group 4751"
                                            >
                                              <path
                                                id="Path_16095"
                                                data-name="Path 16095"
                                                d="M281.746,199.663c.134-.084,5.508-2.594,6.208,3.176s-5.238,5.282-5.268,5.118S281.746,199.663,281.746,199.663Z"
                                                transform="translate(-281.746 -199.048)"
                                                fill="#b47266"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4777"
                      data-name="Group 4777"
                      transform="translate(33.876 19.902)"
                    >
                      <g id="Group_4776" data-name="Group 4776">
                        <g id="Group_4775" data-name="Group 4775">
                          <g id="Group_4774" data-name="Group 4774">
                            <g id="Group_4773" data-name="Group 4773">
                              <g id="Group_4772" data-name="Group 4772">
                                <g id="Group_4771" data-name="Group 4771">
                                  <g id="Group_4770" data-name="Group 4770">
                                    <g id="Group_4769" data-name="Group 4769">
                                      <g id="Group_4768" data-name="Group 4768">
                                        <g
                                          id="Group_4767"
                                          data-name="Group 4767"
                                        >
                                          <g
                                            id="Group_4766"
                                            data-name="Group 4766"
                                          >
                                            <g
                                              id="Group_4765"
                                              data-name="Group 4765"
                                            >
                                              <g
                                                id="Group_4764"
                                                data-name="Group 4764"
                                              >
                                                <path
                                                  id="Path_16096"
                                                  data-name="Path 16096"
                                                  d="M287.861,208.4c.023-.021.109.058.288.116a1.013,1.013,0,0,0,.753-.076,2.505,2.505,0,0,0,.88-2.371,3.345,3.345,0,0,0-.456-1.405,1.169,1.169,0,0,0-.849-.68.515.515,0,0,0-.56.347c-.057.171-.007.281-.037.295-.014.016-.136-.082-.118-.326a.648.648,0,0,1,.183-.389.764.764,0,0,1,.538-.214,1.423,1.423,0,0,1,1.158.767,3.438,3.438,0,0,1,.543,1.566,2.629,2.629,0,0,1-1.164,2.669,1.084,1.084,0,0,1-.938-.041C287.888,208.535,287.843,208.41,287.861,208.4Z"
                                                  transform="translate(-287.762 -203.693)"
                                                  fill="#89544c"
                                                />
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4781"
                      data-name="Group 4781"
                      transform="translate(33.951 25.599)"
                    >
                      <g id="Group_4780" data-name="Group 4780">
                        <g id="Group_4779" data-name="Group 4779">
                          <g id="Group_4778" data-name="Group 4778">
                            <path
                              id="Path_16097"
                              data-name="Path 16097"
                              d="M290.661,219.016c-.005.024.159.052.409.192a1.886,1.886,0,0,1,.784.879,1.648,1.648,0,0,1-.137,1.651,1.956,1.956,0,0,1-1.845.812,2.09,2.09,0,0,1-1.451-3.019,2.567,2.567,0,0,1,.773-.917,3.813,3.813,0,0,0,.375-.258.988.988,0,0,0-.431.173,2.428,2.428,0,0,0-.881.916,2.241,2.241,0,0,0-.167,1.874,2.31,2.31,0,0,0,1.741,1.491,2.176,2.176,0,0,0,2.087-.935,1.8,1.8,0,0,0,.314-.991,1.937,1.937,0,0,0-.209-.875,1.876,1.876,0,0,0-.906-.892A.847.847,0,0,0,290.661,219.016Z"
                              transform="translate(-287.955 -218.354)"
                              fill="#455a64"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4784"
                      data-name="Group 4784"
                      transform="translate(12.962 29.475)"
                    >
                      <g id="Group_4783" data-name="Group 4783">
                        <g id="Group_4782" data-name="Group 4782">
                          <path
                            id="Path_16098"
                            data-name="Path 16098"
                            d="M236.313,233.468c.01-.017.062-.008.141.03a2.06,2.06,0,0,0,.319.143,1.484,1.484,0,0,0,1.151-.3,2.65,2.65,0,0,0,.69-.52,3.06,3.06,0,0,0,.555-.808,1.588,1.588,0,0,0,.111-.985,2.481,2.481,0,0,0-.525-1c-.516-.643-1.164-1.188-1.775-1.139a1.989,1.989,0,0,0-.872.342c-.277.174-.543.349-.771.509a17.529,17.529,0,0,0-1.383,1.19c-.034-.018.009-.2.182-.488a4.466,4.466,0,0,1,.938-1.041c.226-.192.473-.384.755-.589a2.388,2.388,0,0,1,1.1-.48,1.984,1.984,0,0,1,1.311.375,4.656,4.656,0,0,1,.989.94,2.95,2.95,0,0,1,.635,1.258,2.112,2.112,0,0,1-.186,1.34,2.736,2.736,0,0,1-.33.518,4.018,4.018,0,0,1-.377.412,2.882,2.882,0,0,1-.849.545,2.669,2.669,0,0,1-.793.248,1.063,1.063,0,0,1-.651-.116,1.034,1.034,0,0,1-.3-.263C236.325,233.526,236.3,233.486,236.313,233.468Z"
                            transform="translate(-233.943 -228.327)"
                            fill="#263238"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4788"
                    data-name="Group 4788"
                    transform="translate(36.149 7.648)"
                  >
                    <g id="Group_4787" data-name="Group 4787">
                      <g id="Group_4786" data-name="Group 4786">
                        <path
                          id="Path_16099"
                          data-name="Path 16099"
                          d="M275.227,183.433a.308.308,0,0,1,.078,0l.228.021a5.053,5.053,0,0,0,.889-.018,5.773,5.773,0,0,0,3.033-1.32,8.426,8.426,0,0,0,2.6-4.379,10.915,10.915,0,0,0,.392-3.131,6.927,6.927,0,0,0-.9-3.321l-.024-.042.02-.043a7.221,7.221,0,0,0-3.737-9.677l-.154-.066.131-.107a2.327,2.327,0,0,0,.62-.782,3.226,3.226,0,0,0,.129-2.413,6.257,6.257,0,0,0-1.239-2.1,6.481,6.481,0,0,0-1.809-1.531,3.078,3.078,0,0,0-2.184-.375l-.224.055.12-.2a3.541,3.541,0,0,0-3.871-5.293l-.13.033.035-.13a4.666,4.666,0,0,0-.853-4.2,3.772,3.772,0,0,0-.7-.639,3.316,3.316,0,0,0-.787-.392,3.62,3.62,0,0,0-1.528-.181,3.673,3.673,0,0,0-1.2.316,3.227,3.227,0,0,0-.76.5,4.755,4.755,0,0,0-.5.57,1.172,1.172,0,0,1,.1-.166,2.4,2.4,0,0,1,.367-.438,3.178,3.178,0,0,1,.762-.532,3.769,3.769,0,0,1,2.79-.175,3.409,3.409,0,0,1,.818.4,3.862,3.862,0,0,1,.731.654,4.791,4.791,0,0,1,.909,4.328l-.094-.1a3.713,3.713,0,0,1,4.071,5.545l-.1-.143a3.267,3.267,0,0,1,2.322.388,6.66,6.66,0,0,1,1.868,1.575,6.449,6.449,0,0,1,1.279,2.167,3.427,3.427,0,0,1-.14,2.564,2.524,2.524,0,0,1-.675.85l-.024-.172a7.4,7.4,0,0,1,3.823,9.94l0-.085a7.087,7.087,0,0,1,.908,3.409,11.015,11.015,0,0,1-.414,3.175,8.495,8.495,0,0,1-2.681,4.423,5.745,5.745,0,0,1-3.1,1.294,4.586,4.586,0,0,1-.9-.01l-.228-.036A.319.319,0,0,1,275.227,183.433Z"
                          transform="translate(-262.911 -143.094)"
                          fill="#455a64"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4791"
                    data-name="Group 4791"
                    transform="translate(8.937 7.395)"
                  >
                    <g id="Group_4790" data-name="Group 4790">
                      <g id="Group_4789" data-name="Group 4789">
                        <path
                          id="Path_16100"
                          data-name="Path 16100"
                          d="M230.489,162.264c-.152-3.913-.319-7.908-1.721-11.564a5.224,5.224,0,0,0-1.4-2.221,5.151,5.151,0,0,0-1.93-.9c-1.086-.307-1.381-1.043-2.507-1.124a17.728,17.728,0,0,0-15.827-3.414,19.474,19.474,0,0,0-12.369,10.623,21.623,21.623,0,0,0-.464,16.4c-.361-4.16,2.273-8.057,5.5-10.7s7.091-4.4,10.508-6.8a4.035,4.035,0,0,1-1.54,2.98,35.237,35.237,0,0,0,7.868-2.806,15.378,15.378,0,0,0,1.58-1,5.077,5.077,0,0,0,.517,1.823c.916,1.791,2.871,2.748,4.366,4.1a1.591,1.591,0,0,1,.454.573,1.8,1.8,0,0,1-.071,1.11,8.737,8.737,0,0,0-.38,3.609,3.821,3.821,0,0,0,1.96,2.915,3.618,3.618,0,0,0,.226,4.2.906.906,0,0,0,.525.361c.352.053.647-.256.85-.549a7.474,7.474,0,0,0,1.2-2.864,2.765,2.765,0,0,1,.406-1.239c.391-.5,1.11-.6,1.586-1.013A3.059,3.059,0,0,0,230.489,162.264Z"
                          transform="translate(-192.885 -142.443)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4794"
                    data-name="Group 4794"
                    transform="translate(16.148 5.879)"
                  >
                    <g id="Group_4793" data-name="Group 4793">
                      <g id="Group_4792" data-name="Group 4792">
                        <path
                          id="Path_16101"
                          data-name="Path 16101"
                          d="M211.442,150.835a1.364,1.364,0,0,1,.075-.291,3.883,3.883,0,0,1,.373-.777,4.223,4.223,0,0,1,.9-1.024,4.164,4.164,0,0,1,1.6-.824l-.058.067a8.505,8.505,0,0,1,.347-1.654,8.914,8.914,0,0,1,.785-1.732,8.685,8.685,0,0,1,3.01-3,7.149,7.149,0,0,1,1.773-.766,2.6,2.6,0,0,1,.943-.071,1.274,1.274,0,0,1,.827.426l-.15,0a7.436,7.436,0,0,1,2.629-2.131,3.76,3.76,0,0,1,2.615-.426,1.911,1.911,0,0,1,1.277,1.156,1.336,1.336,0,0,1,.075.465.512.512,0,0,1-.023.161,1.706,1.706,0,0,0-1.36-1.665,3.673,3.673,0,0,0-2.511.457,7.364,7.364,0,0,0-2.548,2.1l-.073.1-.077-.092a1.543,1.543,0,0,0-1.575-.284,7.025,7.025,0,0,0-1.718.746,8.6,8.6,0,0,0-2.95,2.926,8.91,8.91,0,0,0-.782,1.688,8.527,8.527,0,0,0-.359,1.615l-.007.054-.051.013a4.227,4.227,0,0,0-2.464,1.746A6.162,6.162,0,0,0,211.442,150.835Z"
                          transform="translate(-211.441 -138.54)"
                          fill="#455a64"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4797"
                    data-name="Group 4797"
                    transform="translate(4.883 4.375)"
                  >
                    <g id="Group_4796" data-name="Group 4796">
                      <g id="Group_4795" data-name="Group 4795">
                        <path
                          id="Path_16102"
                          data-name="Path 16102"
                          d="M186.7,183.23s-.03.051-.1.149l-.31.437-.023.032-.012-.038a12.287,12.287,0,0,1-.617-3.891,12.911,12.911,0,0,1,1.853-6.67l.034.108a4.489,4.489,0,0,1-2.568-4.006,4.028,4.028,0,0,1,.2-1.346,3.446,3.446,0,0,0,.187-.637.729.729,0,0,0-.175-.578,4.645,4.645,0,0,0-.5-.47,5.966,5.966,0,0,1-.512-.509,6.68,6.68,0,0,1-.854-1.193,6.613,6.613,0,0,1,.6-7.352,6.456,6.456,0,0,1,.549-.609c.195-.187.4-.37.4-.6a3.061,3.061,0,0,0-.212-.75,6.533,6.533,0,0,1-.223-.806,7.632,7.632,0,0,1-.171-1.674,8.193,8.193,0,0,1,2.874-6.248,3.636,3.636,0,0,0,1.141-1.154,4.263,4.263,0,0,0,.238-.774c.068-.269.159-.532.237-.8a8.437,8.437,0,0,1,1.628-2.77,9.324,9.324,0,0,1,5.045-2.991,9.153,9.153,0,0,1,2.684-.131,1.064,1.064,0,0,0,.577-.111,2.585,2.585,0,0,0,.454-.4l.449-.421.469-.377a10.03,10.03,0,0,1,1.945-1.143,10.366,10.366,0,0,1,1.914-.616,9.84,9.84,0,0,1,3.2-.174,9.441,9.441,0,0,1,1.982.439l.49.2c.11.045.164.073.164.073s-.06-.015-.172-.054l-.5-.176a9.871,9.871,0,0,0-5.147-.194,10.311,10.311,0,0,0-1.887.623,9.942,9.942,0,0,0-1.91,1.139l-.46.373-.44.417a2.682,2.682,0,0,1-.483.424,1.218,1.218,0,0,1-.658.134c-.222-.012-.434-.031-.651-.032a5.211,5.211,0,0,0-.656,0,8.666,8.666,0,0,0-1.338.169,9.166,9.166,0,0,0-4.939,2.95,8.257,8.257,0,0,0-1.586,2.711c-.075.258-.164.513-.23.778a4.423,4.423,0,0,1-.249.81,3.775,3.775,0,0,1-1.192,1.225,8.007,8.007,0,0,0-2.8,6.1,7.474,7.474,0,0,0,.166,1.631,6.475,6.475,0,0,0,.217.784,3.027,3.027,0,0,1,.222.822,1.142,1.142,0,0,1-.46.734,6.268,6.268,0,0,0-.533.59,6.371,6.371,0,0,0-.589,7.135,6.511,6.511,0,0,0,.828,1.162,5.738,5.738,0,0,0,.5.5,4.706,4.706,0,0,1,.52.494.913.913,0,0,1,.211.712,3.509,3.509,0,0,1-.2.673,3.866,3.866,0,0,0-.2,1.287,4.335,4.335,0,0,0,2.456,3.87l.079.035-.045.074a12.57,12.57,0,0,0-1.474,3.492,12.73,12.73,0,0,0-.406,3.1,12.866,12.866,0,0,0,.554,3.879l-.035-.006.326-.425C186.661,183.274,186.7,183.23,186.7,183.23Z"
                          transform="translate(-182.453 -134.671)"
                          fill="#455a64"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4800"
                    data-name="Group 4800"
                    transform="translate(34.102 1.329)"
                  >
                    <g id="Group_4799" data-name="Group 4799">
                      <g id="Group_4798" data-name="Group 4798">
                        <path
                          id="Path_16103"
                          data-name="Path 16103"
                          d="M267.318,127.1a16.037,16.037,0,0,0-1.836-.127,4.5,4.5,0,0,0-1.9.456,3.1,3.1,0,0,0-1.549,1.733,2.628,2.628,0,0,0-.093.419l-.013.091-.089,0a5,5,0,0,0-2.2.412,3.424,3.424,0,0,0-1.4,1.138,3.034,3.034,0,0,0-.5,1.111c-.06.284-.061.447-.079.447s-.012-.04-.015-.119a1.8,1.8,0,0,1,.02-.341,2.85,2.85,0,0,1,.458-1.176,3.47,3.47,0,0,1,1.433-1.225,5.058,5.058,0,0,1,2.285-.449l-.1.089a2.741,2.741,0,0,1,.1-.456,3.239,3.239,0,0,1,1.657-1.838,4.482,4.482,0,0,1,1.984-.433,6.775,6.775,0,0,1,1.357.139A1.96,1.96,0,0,1,267.318,127.1Z"
                          transform="translate(-257.643 -126.834)"
                          fill="#455a64"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4877"
                  data-name="Group 4877"
                  transform="translate(0 58.488)"
                >
                  <g
                    id="Group_4803"
                    data-name="Group 4803"
                    transform="translate(45.427 28.363)"
                  >
                    <g id="Group_4802" data-name="Group 4802">
                      <path
                        id="Path_16104"
                        data-name="Path 16104"
                        d="M241.221,347.9l28.911-.991,2.681,39.484-25.3.351Z"
                        transform="translate(-241.221 -346.906)"
                        fill="#e0e0e0"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4805"
                    data-name="Group 4805"
                    transform="translate(66.391)"
                  >
                    <g id="Group_4804" data-name="Group 4804">
                      <path
                        id="Path_16105"
                        data-name="Path 16105"
                        d="M296.7,273.932c.393-.494,21.953,14.135,22.914,15.883s6.18,52.307,6.18,52.307l-28.173-.005s-2.588-41.63-2.45-45.474S296.7,273.932,296.7,273.932Z"
                        transform="translate(-295.167 -273.919)"
                        fill={primaryColor}
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4807"
                    data-name="Group 4807"
                    transform="translate(0.052 0.996)"
                  >
                    <g id="Group_4806" data-name="Group 4806">
                      <path
                        id="Path_16106"
                        data-name="Path 16106"
                        d="M127.313,343.919s-3.181-6.538-2.827-9.719,2.827-9.542,2.827-9.542l6.361-11.309s1.272-9.426,1.978-11.193,4.429-13.723,8.847-16.532,17.806-4.735,17.806-4.735l5.935-4.406s5.9,17.429,6.784,22.2,5.831,45.232,5.831,45.232Z"
                        transform="translate(-124.458 -276.482)"
                        fill={primaryColor}
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4810"
                    data-name="Group 4810"
                    transform="translate(37.811 5.638)"
                  >
                    <g id="Group_4809" data-name="Group 4809">
                      <g id="Group_4808" data-name="Group 4808">
                        <path
                          id="Path_16107"
                          data-name="Path 16107"
                          d="M236.323,320.815a.416.416,0,0,1-.067-.083l-.18-.255-.677-.992-2.456-3.671-3.621-5.458-2.132-3.227a10.509,10.509,0,0,1-1.79-3.759,5.941,5.941,0,0,1,.142-2.576,18.184,18.184,0,0,1,.817-2.33l.123.129-3.9,1.35-.111.038-.009-.117-.631-8.264c-.07-.992-.124-1.781-.164-2.338-.015-.26-.027-.465-.036-.619a1.173,1.173,0,0,1,0-.214,1.168,1.168,0,0,1,.031.211l.064.617.214,2.334c.173,2.022.416,4.874.7,8.258l-.12-.078,3.9-1.364.2-.072-.081.2a18.208,18.208,0,0,0-.8,2.306,5.761,5.761,0,0,0-.138,2.491,10.383,10.383,0,0,0,1.757,3.686l2.123,3.233,3.585,5.482,2.4,3.706.645,1.013.163.267A.452.452,0,0,1,236.323,320.815Z"
                          transform="translate(-221.623 -288.429)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4813"
                    data-name="Group 4813"
                    transform="translate(21.684 19.992)"
                  >
                    <g id="Group_4812" data-name="Group 4812">
                      <g id="Group_4811" data-name="Group 4811">
                        <path
                          id="Path_16108"
                          data-name="Path 16108"
                          d="M190.624,372.947a.591.591,0,0,1-.038-.12l-.091-.358c-.079-.329-.19-.791-.331-1.381-.277-1.216-.672-2.951-1.16-5.091-.949-4.317-2.255-10.26-3.7-16.825l-3.667-16.834-1.12-5.1c-.129-.592-.231-1.057-.3-1.387l-.074-.362a.588.588,0,0,1-.019-.125.582.582,0,0,1,.038.12l.094.357.34,1.378c.288,1.2.694,2.936,1.183,5.086.98,4.3,2.293,10.247,3.725,16.822l3.64,16.838,1.1,5.105.294,1.389.071.362A.593.593,0,0,1,190.624,372.947Z"
                          transform="translate(-180.123 -325.364)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4816"
                    data-name="Group 4816"
                    transform="translate(29.173 55.109)"
                    opacity="0.3"
                  >
                    <g id="Group_4815" data-name="Group 4815">
                      <g id="Group_4814" data-name="Group 4814">
                        <path
                          id="Path_16109"
                          data-name="Path 16109"
                          d="M199.852,428.469a21.534,21.534,0,0,1,9.379-2.952c2.547-.188,5.172.072,7.6-.715,2.725-.883,4.862-2.968,6.893-4.987a5.013,5.013,0,0,0,1.373-1.876,1.718,1.718,0,0,0-.656-2.054,2.473,2.473,0,0,0-1.767.031,60.7,60.7,0,0,0-23.282,12.378"
                          transform="translate(-199.394 -415.731)"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4819"
                    data-name="Group 4819"
                    transform="translate(5.677 46.177)"
                  >
                    <g id="Group_4818" data-name="Group 4818">
                      <g id="Group_4817" data-name="Group 4817">
                        <path
                          id="Path_16110"
                          data-name="Path 16110"
                          d="M155.356,399.854a6.721,6.721,0,0,1-.426-.615,15.019,15.019,0,0,0-1.254-1.6,14.1,14.1,0,0,0-12.012-4.653,15.07,15.07,0,0,0-2,.335,6.953,6.953,0,0,1-.729.168.711.711,0,0,1,.18-.075c.12-.04.3-.108.529-.17a12.678,12.678,0,0,1,2.007-.4,13.782,13.782,0,0,1,12.135,4.7A12.66,12.66,0,0,1,155,399.2c.131.2.215.372.277.483A.719.719,0,0,1,155.356,399.854Z"
                          transform="translate(-138.934 -392.747)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4822"
                    data-name="Group 4822"
                    transform="translate(11.407 38.771)"
                  >
                    <g id="Group_4821" data-name="Group 4821">
                      <g id="Group_4820" data-name="Group 4820">
                        <path
                          id="Path_16111"
                          data-name="Path 16111"
                          d="M167.462,386.654a.749.749,0,0,1-.091-.179l-.223-.527c-.091-.231-.208-.511-.366-.826s-.312-.686-.535-1.069l-.334-.609c-.117-.211-.259-.42-.394-.642-.265-.449-.6-.9-.933-1.374a21.327,21.327,0,0,0-5.515-5.187c-.5-.307-.964-.611-1.428-.848-.23-.122-.447-.25-.665-.354l-.629-.3c-.4-.2-.774-.333-1.1-.469s-.61-.238-.846-.314l-.539-.19a.773.773,0,0,1-.185-.08.728.728,0,0,1,.2.04l.552.154a8.357,8.357,0,0,1,.862.284c.331.126.715.251,1.118.444l.639.286c.221.1.441.227.675.347.471.232.945.533,1.45.839a20.573,20.573,0,0,1,5.564,5.233c.336.485.665.94.926,1.4.134.226.273.438.387.653l.325.621c.216.39.365.766.511,1.089a8.319,8.319,0,0,1,.336.843l.188.542A.743.743,0,0,1,167.462,386.654Z"
                          transform="translate(-153.679 -373.689)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4825"
                    data-name="Group 4825"
                    transform="translate(81.099 32.983)"
                  >
                    <g id="Group_4824" data-name="Group 4824">
                      <g id="Group_4823" data-name="Group 4823">
                        <path
                          id="Path_16112"
                          data-name="Path 16112"
                          d="M335.869,358.795a.3.3,0,0,1-.012.089l-.054.257q-.084.363-.227.984c-.2.853-.492,2.088-.821,3.619a63.814,63.814,0,0,0-1.526,12.114,34.668,34.668,0,0,0,.478,6.7,27.206,27.206,0,0,0,1.442,5.286,23.954,23.954,0,0,0,1.59,3.34c.211.384.4.663.52.863l.134.226a.312.312,0,0,1,.04.081s-.022-.021-.057-.07l-.151-.215c-.126-.193-.332-.467-.553-.846a21.968,21.968,0,0,1-1.656-3.327,26.54,26.54,0,0,1-1.493-5.306,33.985,33.985,0,0,1-.5-6.733,60.494,60.494,0,0,1,1.588-12.14c.348-1.529.661-2.759.884-3.607l.264-.975.074-.252A.3.3,0,0,1,335.869,358.795Z"
                          transform="translate(-333.018 -358.795)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4828"
                    data-name="Group 4828"
                    transform="translate(81.137 20.602)"
                  >
                    <g id="Group_4827" data-name="Group 4827">
                      <g id="Group_4826" data-name="Group 4826">
                        <path
                          id="Path_16113"
                          data-name="Path 16113"
                          d="M333.2,355.786a1.608,1.608,0,0,1,.01-.294c.018-.211.041-.49.071-.839.036-.364.069-.809.106-1.327s.084-1.107.119-1.759c.165-2.608.276-6.218.25-10.205s-.186-7.6-.353-10.205c-.078-1.3-.16-2.359-.216-3.088-.025-.349-.046-.628-.061-.84a1.622,1.622,0,0,1-.008-.294,1.576,1.576,0,0,1,.049.29l.1.836c.08.727.185,1.781.281,3.085.2,2.608.381,6.22.413,10.214s-.108,7.607-.309,10.216c-.045.653-.1,1.242-.15,1.76s-.093.963-.141,1.326c-.045.347-.081.625-.108.836A1.658,1.658,0,0,1,333.2,355.786Z"
                          transform="translate(-333.115 -326.934)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4831"
                    data-name="Group 4831"
                    transform="translate(67.022 12.965)"
                  >
                    <g id="Group_4830" data-name="Group 4830">
                      <g id="Group_4829" data-name="Group 4829">
                        <path
                          id="Path_16114"
                          data-name="Path 16114"
                          d="M302.923,307.282a1.149,1.149,0,0,1-.08.324,2.007,2.007,0,0,1-.558.78,2.918,2.918,0,0,1-1.369.661,8.043,8.043,0,0,1-2.016.087l.021-.14,2.608.647.071.017-.007.073c-.253,2.556-.624,5.618-1.16,8.886-.727,4.49-1.624,8.511-2.347,11.4-.366,1.444-.681,2.607-.91,3.408l-.271.92a2.085,2.085,0,0,1-.108.317,2.113,2.113,0,0,1,.068-.328l.234-.93c.206-.807.5-1.974.848-3.421.687-2.9,1.56-6.916,2.286-11.4.536-3.263.917-6.32,1.191-8.871l.064.091-2.6-.673.021-.14a8.115,8.115,0,0,0,1.988-.056,2.876,2.876,0,0,0,1.34-.609,2.069,2.069,0,0,0,.572-.736C302.892,307.393,302.912,307.28,302.923,307.282Z"
                          transform="translate(-296.793 -307.282)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4834"
                    data-name="Group 4834"
                    transform="translate(19.386 23.122)"
                    opacity="0.3"
                  >
                    <g id="Group_4833" data-name="Group 4833">
                      <g id="Group_4832" data-name="Group 4832">
                        <path
                          id="Path_16115"
                          data-name="Path 16115"
                          d="M177.555,335.129a6.071,6.071,0,0,0-1.439-1.465,1.167,1.167,0,0,0-1.881,1.222,4.125,4.125,0,0,0,.51,1.217,43.442,43.442,0,0,1,4.86,14.7c.31,2.2.451,4.427.925,6.6a10.416,10.416,0,0,0,2.476,5.447l.621-.263a17.143,17.143,0,0,0-.3-1.736c-2.025-8.445-3.8-16.872-5.768-25.715"
                          transform="translate(-174.209 -333.419)"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4837"
                    data-name="Group 4837"
                    transform="translate(6.611 45.231)"
                    opacity="0.3"
                  >
                    <g id="Group_4836" data-name="Group 4836">
                      <g id="Group_4835" data-name="Group 4835">
                        <path
                          id="Path_16116"
                          data-name="Path 16116"
                          d="M157.082,398.436a7.8,7.8,0,0,0-3.183-5.03,17.239,17.239,0,0,0-5.519-2.549,9.565,9.565,0,0,0-3.242-.536c-1.1.06-3.157.53-3.8,1.423,7.278-1.714,12.564,1.662,15.474,6.864"
                          transform="translate(-141.335 -390.313)"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4840"
                    data-name="Group 4840"
                    transform="translate(78.282 27.256)"
                    opacity="0.3"
                  >
                    <g id="Group_4839" data-name="Group 4839">
                      <g id="Group_4838" data-name="Group 4838">
                        <path
                          id="Path_16117"
                          data-name="Path 16117"
                          d="M328.975,344.058c-.552,5.984-2.161,11.824-2.875,17.792s-.45,12.309,2.489,17.551a8.02,8.02,0,0,0,4.316,4.036,18.807,18.807,0,0,1-3.855-9.928,67.529,67.529,0,0,1-.014-10.789q.41-9.324.03-18.662"
                          transform="translate(-325.768 -344.057)"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4843"
                    data-name="Group 4843"
                    transform="translate(10.721 28.773)"
                  >
                    <g id="Group_4842" data-name="Group 4842">
                      <g id="Group_4841" data-name="Group 4841">
                        <path
                          id="Path_16118"
                          data-name="Path 16118"
                          d="M164.823,348.209a2.563,2.563,0,0,1-.478.206,12.728,12.728,0,0,1-1.354.428,16.676,16.676,0,0,1-2.069.407,17.255,17.255,0,0,1-5.151-.1,16.643,16.643,0,0,1-2.052-.485,12.58,12.58,0,0,1-1.337-.478,2.566,2.566,0,0,1-.471-.224,2.608,2.608,0,0,1,.5.15c.314.113.775.257,1.349.415a19.172,19.172,0,0,0,2.042.438,18.585,18.585,0,0,0,5.1.1,19.135,19.135,0,0,0,2.057-.361c.579-.136,1.046-.262,1.363-.363A2.562,2.562,0,0,1,164.823,348.209Z"
                          transform="translate(-151.912 -347.962)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4846"
                    data-name="Group 4846"
                    transform="translate(22.832 13.2)"
                  >
                    <g id="Group_4845" data-name="Group 4845">
                      <g id="Group_4844" data-name="Group 4844">
                        <path
                          id="Path_16119"
                          data-name="Path 16119"
                          d="M203.71,319.533a8.94,8.94,0,0,1-1.558,1.045,11.93,11.93,0,0,1-8.425,1.12,11.449,11.449,0,0,1-3.709-1.653,11.91,11.91,0,0,1-4.336-5.246,8.742,8.742,0,0,1-.674-2.363,5.39,5.39,0,0,1,.2-2.455,3.067,3.067,0,0,1,1.553-1.807,3.31,3.31,0,0,1,2.3-.147,3.481,3.481,0,0,1,1.84,1.229,4.046,4.046,0,0,1,.789,1.954,4.92,4.92,0,0,1-.144,1.983,6,6,0,0,1-1.978,2.916,8.9,8.9,0,0,1-2.529,1.46,14.636,14.636,0,0,1-2.114.623c-.591.128-1.054.2-1.368.254l-.358.051a.555.555,0,0,1-.123.01.6.6,0,0,1,.12-.03l.354-.071c.312-.062.771-.151,1.357-.291a15.218,15.218,0,0,0,2.091-.651A8.894,8.894,0,0,0,189.478,316a5.875,5.875,0,0,0,1.908-2.852,4.764,4.764,0,0,0,.129-1.914,3.869,3.869,0,0,0-.761-1.865,3.3,3.3,0,0,0-1.745-1.156,3.117,3.117,0,0,0-2.163.14,2.869,2.869,0,0,0-1.448,1.694,5.2,5.2,0,0,0-.189,2.363,8.571,8.571,0,0,0,.659,2.311,11.768,11.768,0,0,0,4.255,5.17,11.338,11.338,0,0,0,3.645,1.644,11.867,11.867,0,0,0,3.479.314,12.084,12.084,0,0,0,4.868-1.34c.267-.138.5-.267.7-.393s.366-.221.494-.316l.3-.2A.588.588,0,0,1,203.71,319.533Z"
                          transform="translate(-183.077 -307.887)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4849"
                    data-name="Group 4849"
                    transform="translate(38.359 9.48)"
                  >
                    <g id="Group_4848" data-name="Group 4848">
                      <g id="Group_4847" data-name="Group 4847">
                        <path
                          id="Path_16120"
                          data-name="Path 16120"
                          d="M231.019,298.328c0,.035-.5.073-1.284.221a13.572,13.572,0,0,0-5.673,2.5c-.641.481-1,.823-1.029.8s.072-.1.23-.267a8.2,8.2,0,0,1,.711-.644,11.837,11.837,0,0,1,5.737-2.528,8.127,8.127,0,0,1,.955-.09A1.188,1.188,0,0,1,231.019,298.328Z"
                          transform="translate(-223.033 -298.314)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4852"
                    data-name="Group 4852"
                    transform="translate(28.392 38.625)"
                  >
                    <g id="Group_4851" data-name="Group 4851">
                      <g id="Group_4850" data-name="Group 4850">
                        <path
                          id="Path_16121"
                          data-name="Path 16121"
                          d="M221.729,374.458a.781.781,0,0,1-.135-.052l-.386-.171a10.216,10.216,0,0,0-1.537-.508,11.058,11.058,0,0,0-5.875.212,12.659,12.659,0,0,0-1.824.735,12.793,12.793,0,0,0-1.8,1.138A13.739,13.739,0,0,0,207,379.262a15.312,15.312,0,0,0-2.044,4.758,4.937,4.937,0,0,0,.026,2.679,2.85,2.85,0,0,0,1.973,1.77,4.785,4.785,0,0,0,2.753-.062,5.453,5.453,0,0,0,2.282-1.427,4.057,4.057,0,0,0,1.122-2.308,3.582,3.582,0,0,0-.087-1.252,4.257,4.257,0,0,0-.491-1.131,5.941,5.941,0,0,0-1.685-1.688,8.023,8.023,0,0,0-2.044-.985,11.476,11.476,0,0,0-2.078-.464,11.983,11.983,0,0,0-7.592,1.674,11.435,11.435,0,0,0-1.315.945l-.323.272a.735.735,0,0,1-.115.088.791.791,0,0,1,.1-.1l.31-.288a10.3,10.3,0,0,1,1.3-.981,11.758,11.758,0,0,1,5.661-1.811,12.028,12.028,0,0,1,1.991.049,11.548,11.548,0,0,1,2.112.459,8.173,8.173,0,0,1,2.091,1,6.108,6.108,0,0,1,1.743,1.736,4.452,4.452,0,0,1,.517,1.183,3.767,3.767,0,0,1,.1,1.32,4.246,4.246,0,0,1-1.169,2.422,5.642,5.642,0,0,1-2.366,1.483,4.979,4.979,0,0,1-2.871.064,3.054,3.054,0,0,1-2.106-1.9,5.12,5.12,0,0,1-.03-2.79,15.421,15.421,0,0,1,2.081-4.816,13.843,13.843,0,0,1,3.224-3.483,11.456,11.456,0,0,1,3.685-1.876,10.994,10.994,0,0,1,5.936-.151,9.38,9.38,0,0,1,1.534.547l.378.19A.73.73,0,0,1,221.729,374.458Z"
                          transform="translate(-197.385 -373.315)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4855"
                    data-name="Group 4855"
                    transform="translate(11.695 41.298)"
                  >
                    <g id="Group_4854" data-name="Group 4854">
                      <g id="Group_4853" data-name="Group 4853">
                        <path
                          id="Path_16122"
                          data-name="Path 16122"
                          d="M160,380.2c.006.038-.436.094-1.1.326a7.066,7.066,0,0,0-1.128.511,7.12,7.12,0,0,0-2.249,2,7.059,7.059,0,0,0-.64,1.06c-.309.636-.417,1.068-.453,1.058a.933.933,0,0,1,.05-.309,4.569,4.569,0,0,1,.274-.809,6.2,6.2,0,0,1,.619-1.109,6.69,6.69,0,0,1,2.311-2.054,6.236,6.236,0,0,1,1.174-.484,4.6,4.6,0,0,1,.835-.177A.946.946,0,0,1,160,380.2Z"
                          transform="translate(-154.42 -380.193)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4858"
                    data-name="Group 4858"
                    transform="translate(0 54.51)"
                  >
                    <g id="Group_4857" data-name="Group 4857">
                      <g id="Group_4856" data-name="Group 4856">
                        <path
                          id="Path_16123"
                          data-name="Path 16123"
                          d="M154.7,420.91a.671.671,0,0,1-.1-.092l-.267-.283c-.234-.248-.579-.616-1.037-1.074a21.367,21.367,0,0,0-4.275-3.4,12.535,12.535,0,0,0-3.48-1.414,10.351,10.351,0,0,0-4.284-.1,7.341,7.341,0,0,0-4.086,2.25,4.149,4.149,0,0,0-1.038,2.217,3.03,3.03,0,0,0,.675,2.367,2.4,2.4,0,0,0,2.281.737,1.89,1.89,0,0,0,1.012-.641,2.5,2.5,0,0,0,.511-1.088,3.284,3.284,0,0,0-.387-2.3,4.7,4.7,0,0,0-1.587-1.643,6.68,6.68,0,0,0-4.13-.879,15.917,15.917,0,0,0-3.68.8,19.794,19.794,0,0,0-4.891,2.427c-.537.363-.933.673-1.2.881l-.3.242a.661.661,0,0,1-.108.077,13.035,13.035,0,0,1,1.57-1.265,19.22,19.22,0,0,1,4.891-2.5,15.886,15.886,0,0,1,3.713-.829,6.832,6.832,0,0,1,4.243.889A4.88,4.88,0,0,1,140.4,418a3.477,3.477,0,0,1,.412,2.437,2.694,2.694,0,0,1-.551,1.175,2.09,2.09,0,0,1-1.118.708,2.593,2.593,0,0,1-2.48-.8,3.227,3.227,0,0,1-.724-2.525,4.34,4.34,0,0,1,1.088-2.324,7.511,7.511,0,0,1,4.2-2.3,10.481,10.481,0,0,1,4.358.116,12.571,12.571,0,0,1,3.514,1.454,20.7,20.7,0,0,1,4.259,3.47c.451.468.786.844,1.011,1.1l.252.3A.652.652,0,0,1,154.7,420.91Z"
                          transform="translate(-124.324 -414.19)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4861"
                    data-name="Group 4861"
                    transform="translate(68.093 45.193)"
                  >
                    <g id="Group_4860" data-name="Group 4860">
                      <g id="Group_4859" data-name="Group 4859">
                        <path
                          id="Path_16124"
                          data-name="Path 16124"
                          d="M312.773,395.278a1.763,1.763,0,0,1-.255.176c-.086.053-.19.126-.32.2l-.46.231c-.174.085-.379.153-.6.242s-.47.145-.736.219a8.627,8.627,0,0,1-1.857.218,8,8,0,0,1-4.591-1.441,4.983,4.983,0,0,1-1.858-2.191,2.29,2.29,0,0,1-.007-1.549,1.755,1.755,0,0,1,1.177-1.067,3.343,3.343,0,0,1,2.957.738,3.265,3.265,0,0,1,.912,1.179,2.45,2.45,0,0,1,.18,1.422,2.931,2.931,0,0,1-.569,1.236,4.944,4.944,0,0,1-.909.893,10.294,10.294,0,0,1-1.957,1.142,11.425,11.425,0,0,1-3.139.906c-.383.052-.682.073-.886.082a1.788,1.788,0,0,1-.31,0,1.764,1.764,0,0,1,.307-.04c.2-.022.5-.056.877-.119a12.02,12.02,0,0,0,3.091-.959,10.325,10.325,0,0,0,1.914-1.144,3.493,3.493,0,0,0,1.4-2.03A2.6,2.6,0,0,0,306.1,391.2a3.157,3.157,0,0,0-2.773-.7,1.552,1.552,0,0,0-1.046.944,2.1,2.1,0,0,0,.006,1.413,4.825,4.825,0,0,0,1.779,2.1,7.929,7.929,0,0,0,4.483,1.45,8.806,8.806,0,0,0,1.831-.185c.262-.068.509-.128.73-.2s.422-.144.6-.222l.463-.212c.132-.067.238-.133.327-.18A1.778,1.778,0,0,1,312.773,395.278Z"
                          transform="translate(-299.549 -390.214)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4864"
                    data-name="Group 4864"
                    transform="translate(66.291 23.491)"
                  >
                    <g id="Group_4863" data-name="Group 4863">
                      <g id="Group_4862" data-name="Group 4862">
                        <path
                          id="Path_16125"
                          data-name="Path 16125"
                          d="M298.718,334.386a9.264,9.264,0,0,0-3.805,1.8,5.2,5.2,0,0,1,3.805-1.8Z"
                          transform="translate(-294.911 -334.369)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4867"
                    data-name="Group 4867"
                    transform="translate(46.208 23.597)"
                  >
                    <g id="Group_4866" data-name="Group 4866">
                      <g id="Group_4865" data-name="Group 4865">
                        <path
                          id="Path_16126"
                          data-name="Path 16126"
                          d="M247.566,334.642a2.876,2.876,0,0,1-.305.9,7.013,7.013,0,0,1-3.143,3.25,2.87,2.87,0,0,1-.887.335,8.72,8.72,0,0,0,4.335-4.483Z"
                          transform="translate(-243.231 -334.642)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4870"
                    data-name="Group 4870"
                    transform="translate(67.662 5.257)"
                  >
                    <g id="Group_4869" data-name="Group 4869">
                      <g id="Group_4868" data-name="Group 4868">
                        <path
                          id="Path_16127"
                          data-name="Path 16127"
                          d="M306.683,287.452c0,.018-.277.053-.769.177a11.011,11.011,0,0,0-3.292,1.463,4.613,4.613,0,0,0-1.209,1.147,2.773,2.773,0,0,0-.513,1.715,1.97,1.97,0,0,0,.269.9,1.669,1.669,0,0,0,.717.63,1.6,1.6,0,0,0,.941.142,1.178,1.178,0,0,0,.765-.469,1.662,1.662,0,0,0,.06-1.693,1.934,1.934,0,0,0-1.282-.93,3.01,3.01,0,0,0-1.435.022,5.423,5.423,0,0,0-1.869.992c-.4.309-.615.494-.626.482a.771.771,0,0,1,.14-.151c.1-.094.241-.229.437-.393a5.2,5.2,0,0,1,1.882-1.069,3.123,3.123,0,0,1,1.511-.047,2.1,2.1,0,0,1,1.408,1.006,1.844,1.844,0,0,1-.065,1.9,1.376,1.376,0,0,1-.891.551,1.8,1.8,0,0,1-1.061-.157,1.864,1.864,0,0,1-.8-.71,2.155,2.155,0,0,1-.294-.994,2.943,2.943,0,0,1,.558-1.833,4.724,4.724,0,0,1,1.267-1.179,10.108,10.108,0,0,1,1.316-.717,9.4,9.4,0,0,1,2.052-.683c.251-.051.448-.077.581-.092A.823.823,0,0,1,306.683,287.452Z"
                          transform="translate(-298.439 -287.448)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4873"
                    data-name="Group 4873"
                    transform="translate(70.949 19.069)"
                  >
                    <g id="Group_4872" data-name="Group 4872">
                      <g id="Group_4871" data-name="Group 4871">
                        <path
                          id="Path_16128"
                          data-name="Path 16128"
                          d="M316.923,333.006a1.935,1.935,0,0,1-.2.261c-.069.083-.172.169-.286.279a3.311,3.311,0,0,1-.449.311,4.173,4.173,0,0,1-3.385.263,4.469,4.469,0,0,1-1.977-1.349,6.471,6.471,0,0,1-1.284-2.433,8.626,8.626,0,0,1-.307-3.025,5.419,5.419,0,0,1,1.11-3.059,3.409,3.409,0,0,1,2.962-1.243,2.417,2.417,0,0,1,1.421.688,2.022,2.022,0,0,1,.6,1.39,1.949,1.949,0,0,1-.57,1.323,2.928,2.928,0,0,1-1.137.736,4.5,4.5,0,0,1-2.39.154,6.653,6.653,0,0,1-1.861-.67,11.726,11.726,0,0,1-1.267-.784c-.334-.234-.586-.427-.755-.558a1.972,1.972,0,0,1-.251-.211,2.092,2.092,0,0,1,.276.178l.775.526a12.724,12.724,0,0,0,1.274.748,6.649,6.649,0,0,0,1.835.63,4.376,4.376,0,0,0,2.306-.17,2.769,2.769,0,0,0,1.067-.7,1.771,1.771,0,0,0,.513-1.2,1.836,1.836,0,0,0-.553-1.254,2.225,2.225,0,0,0-1.308-.627,3.219,3.219,0,0,0-2.781,1.175,5.243,5.243,0,0,0-1.068,2.945,8.5,8.5,0,0,0,.288,2.958,6.344,6.344,0,0,0,1.231,2.375,4.347,4.347,0,0,0,1.9,1.323,4.137,4.137,0,0,0,3.3-.2A3.783,3.783,0,0,0,316.923,333.006Z"
                          transform="translate(-306.899 -322.99)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4876"
                    data-name="Group 4876"
                    transform="translate(81.863 25.826)"
                  >
                    <g id="Group_4875" data-name="Group 4875">
                      <g id="Group_4874" data-name="Group 4874">
                        <path
                          id="Path_16129"
                          data-name="Path 16129"
                          d="M345,340.838a16.559,16.559,0,0,0-1.766-.277,8.134,8.134,0,0,0-7.375,3.567,16.516,16.516,0,0,0-.879,1.556,1.891,1.891,0,0,1,.149-.461,7.058,7.058,0,0,1,.61-1.174,7.92,7.92,0,0,1,7.506-3.63,7.085,7.085,0,0,1,1.3.25A1.931,1.931,0,0,1,345,340.838Z"
                          transform="translate(-334.982 -340.376)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4880"
                  data-name="Group 4880"
                  transform="translate(67.148 62.829)"
                  opacity="0.3"
                >
                  <g id="Group_4879" data-name="Group 4879">
                    <g id="Group_4878" data-name="Group 4878">
                      <path
                        id="Path_16130"
                        data-name="Path 16130"
                        d="M297.528,285.092c4.386,2.135,9.7,2.259,13.621,5.161a11.431,11.431,0,0,1,3.037,15.011c-.284-2.473-.767-5.28-2.871-6.611a15.293,15.293,0,0,0-3.03-1.152c-1.146-.419-2.2-1.062-3.367-1.432-1.57-.5-3.269-.481-4.833-.995s-3.082-1.851-2.964-3.493Z"
                        transform="translate(-297.115 -285.092)"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4908"
                  data-name="Group 4908"
                  transform="translate(62.446 56.155)"
                >
                  <g id="Group_4905" data-name="Group 4905">
                    <g id="Group_4886" data-name="Group 4886">
                      <g
                        id="Group_4882"
                        data-name="Group 4882"
                        transform="translate(0.142 0.095)"
                      >
                        <g id="Group_4881" data-name="Group 4881">
                          <path
                            id="Path_16131"
                            data-name="Path 16131"
                            d="M306.951,294.238l-.623-7.815s-4.239-.82-5.743-1.778-4.258-2.934-4.258-2.934-.665,2.387-2.032,2.524l-1.231.137-.043-4.822s-.234,2.162-2.008,2.5c-.4.076-.41,0-.41,0l-1.2-6.3a3.2,3.2,0,0,1-4.022.611s4.211-7.341,5.032-7.615a42.353,42.353,0,0,1,5.249-.371s6.153-.38,6.837-.122a6.072,6.072,0,0,1,1.641,1.352s7.247,6.974,9.572,9.3a13.85,13.85,0,0,1,3.555,6.974c.137,1.231,1.173,6.354,1.173,6.354"
                            transform="translate(-285.382 -268.162)"
                            fill="#b47266"
                          />
                        </g>
                      </g>
                      <g id="Group_4885" data-name="Group 4885">
                        <g id="Group_4884" data-name="Group 4884">
                          <g id="Group_4883" data-name="Group 4883">
                            <path
                              id="Path_16132"
                              data-name="Path 16132"
                              d="M318.217,292.082s-.014-.043-.033-.127-.048-.217-.084-.38c-.071-.343-.173-.838-.307-1.48l-.466-2.383c-.087-.469-.181-.972-.267-1.512-.047-.27-.07-.552-.127-.831s-.132-.568-.216-.86a15.027,15.027,0,0,0-1.662-3.649,11.982,11.982,0,0,0-1.378-1.8c-.541-.567-1.147-1.122-1.746-1.712l-8.078-7.826,0,0,0,0a9.042,9.042,0,0,0-.78-.772,2.527,2.527,0,0,0-.909-.57,7.433,7.433,0,0,0-1.116-.064c-.382,0-.767,0-1.155.013-1.552.035-3.136.132-4.765.209-.811.023-1.631.055-2.457.1-.412.024-.827.05-1.242.086a6.875,6.875,0,0,0-1.214.181,1.825,1.825,0,0,0-.421.4c-.133.16-.262.326-.387.5-.25.34-.49.691-.726,1.047-.473.711-.93,1.441-1.384,2.179q-1.057,1.724-2.046,3.44l-.044-.141a3.806,3.806,0,0,0,2.088.385,2.937,2.937,0,0,0,1.812-.965l.138-.16.038.2q.615,3.24,1.2,6.3l0,.014v-.006c-.015-.059-.023-.044-.027-.054l-.007,0,.009,0a.29.29,0,0,0,.045,0,.785.785,0,0,0,.11-.006,1.383,1.383,0,0,0,.23-.042l.226-.059.215-.09a2.166,2.166,0,0,0,.723-.566,3.446,3.446,0,0,0,.707-1.681l.185.009q.019,2.5.037,4.822l-.1-.087,1.2-.131a1.516,1.516,0,0,0,.959-.516,5.105,5.105,0,0,0,1.039-1.947l.034-.107.092.063,2.618,1.811,1.234.854a5.473,5.473,0,0,0,1.24.694,20.621,20.621,0,0,0,2.538.819c.818.215,1.6.4,2.334.545l.042.009,0,.042c.186,2.471.332,4.424.433,5.766.046.662.082,1.174.107,1.527.01.168.018.3.024.392s0,.133,0,.133-.009-.044-.018-.132l-.039-.391c-.031-.353-.077-.863-.136-1.525-.113-1.341-.277-3.293-.485-5.762l.045.051c-.74-.146-1.523-.321-2.345-.532a20.69,20.69,0,0,1-2.56-.813,5.59,5.59,0,0,1-1.265-.7l-1.239-.85-2.629-1.8.125-.044a5.251,5.251,0,0,1-1.073,2.02,1.686,1.686,0,0,1-1.063.57l-1.2.134-.1.011v-.1q-.023-2.324-.048-4.822l.185.009a3.625,3.625,0,0,1-.747,1.782,2.349,2.349,0,0,1-.787.617c-.078.033-.155.069-.235.1l-.246.065a1.533,1.533,0,0,1-.251.046,1,1,0,0,1-.135.007.475.475,0,0,1-.077-.007.245.245,0,0,1-.049-.015.154.154,0,0,1-.034-.02c-.013-.017-.028-.009-.046-.078v.008l-1.2-6.3.176.042a3.124,3.124,0,0,1-1.943,1.043,4.007,4.007,0,0,1-2.2-.4l-.1-.047.054-.095q.99-1.716,2.048-3.445c.455-.74.913-1.471,1.388-2.185.238-.357.479-.71.733-1.054q.189-.259.395-.506a1.837,1.837,0,0,1,.5-.457,6.846,6.846,0,0,1,1.27-.194c.418-.036.834-.062,1.248-.085.828-.045,1.65-.075,2.463-.1,1.617-.075,3.212-.171,4.766-.2.389-.008.775-.014,1.16-.011a7.273,7.273,0,0,1,1.161.072,2.677,2.677,0,0,1,.985.612,9.175,9.175,0,0,1,.8.792l-.005-.006,8.059,7.85c.6.594,1.2,1.146,1.743,1.722a12.071,12.071,0,0,1,1.386,1.827,15.058,15.058,0,0,1,1.655,3.688c.083.3.16.585.212.872s.077.569.122.836c.082.538.171,1.043.253,1.512.173.936.319,1.735.44,2.387s.214,1.141.279,1.485l.069.382C318.213,292.037,318.217,292.082,318.217,292.082Z"
                              transform="translate(-285.017 -267.918)"
                              fill="#89544c"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4889"
                      data-name="Group 4889"
                      transform="translate(4.045 0.673)"
                    >
                      <g id="Group_4888" data-name="Group 4888">
                        <g id="Group_4887" data-name="Group 4887">
                          <path
                            id="Path_16133"
                            data-name="Path 16133"
                            d="M302.844,269.655c.007.034-.643.15-1.645.5a24.942,24.942,0,0,0-3.768,1.713,3.483,3.483,0,0,0-.926.681,2.981,2.981,0,0,0-.574.9,4.137,4.137,0,0,0-.358,1.783c0,.527.04.959.043,1.257a1.829,1.829,0,0,1-.016.464,2.29,2.29,0,0,1-.063-.459c-.027-.3-.085-.722-.107-1.259a4.131,4.131,0,0,1,.331-1.86,3.108,3.108,0,0,1,.6-.959,3.614,3.614,0,0,1,.973-.722,21.035,21.035,0,0,1,3.82-1.671,10.586,10.586,0,0,1,1.228-.307A1.807,1.807,0,0,1,302.844,269.655Z"
                            transform="translate(-295.426 -269.65)"
                            fill="#89544c"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4892"
                      data-name="Group 4892"
                      transform="translate(7.545 2.049)"
                    >
                      <g id="Group_4891" data-name="Group 4891">
                        <g id="Group_4890" data-name="Group 4890">
                          <path
                            id="Path_16134"
                            data-name="Path 16134"
                            d="M312.969,273.193a3.7,3.7,0,0,1-.6.186c-.385.117-.946.271-1.615.526a14.337,14.337,0,0,0-2.254,1.108c-.412.237-.846.489-1.306.73s-.963.452-1.414.734a2.11,2.11,0,0,0-.573.518,2.171,2.171,0,0,0-.315.682,8.719,8.719,0,0,0-.241,1.453,18.681,18.681,0,0,0-.011,2.515c.035.718.069,1.3.079,1.7a3.394,3.394,0,0,1-.009.626,4.16,4.16,0,0,1-.07-.622c-.036-.436-.085-1.008-.143-1.7a17.068,17.068,0,0,1-.032-2.538,8.627,8.627,0,0,1,.236-1.492,2.35,2.35,0,0,1,.344-.746,2.283,2.283,0,0,1,.626-.569c.482-.3.979-.493,1.431-.74s.891-.483,1.306-.717a13.367,13.367,0,0,1,2.3-1.08,15.31,15.31,0,0,1,1.645-.468A3.714,3.714,0,0,1,312.969,273.193Z"
                            transform="translate(-304.432 -273.19)"
                            fill="#89544c"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4895"
                      data-name="Group 4895"
                      transform="translate(10.669 4.098)"
                    >
                      <g id="Group_4894" data-name="Group 4894">
                        <g id="Group_4893" data-name="Group 4893">
                          <path
                            id="Path_16135"
                            data-name="Path 16135"
                            d="M320.139,278.466a2.873,2.873,0,0,1-.5.2c-.324.115-.791.284-1.356.521a11.728,11.728,0,0,0-3.966,2.579,6.144,6.144,0,0,0-1.345,2.205,6.348,6.348,0,0,0-.355,2.091,8.985,8.985,0,0,0,.271,1.952c-.007,0-.027-.04-.061-.125a3.583,3.583,0,0,1-.13-.377,5.658,5.658,0,0,1-.223-1.449,6.2,6.2,0,0,1,1.7-4.438,11.157,11.157,0,0,1,4.059-2.572c.577-.221,1.053-.37,1.385-.463A2.561,2.561,0,0,1,320.139,278.466Z"
                            transform="translate(-312.473 -278.464)"
                            fill="#89544c"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4898"
                      data-name="Group 4898"
                      transform="translate(11.087 8.55)"
                    >
                      <g id="Group_4897" data-name="Group 4897">
                        <g id="Group_4896" data-name="Group 4896">
                          <path
                            id="Path_16136"
                            data-name="Path 16136"
                            d="M323.141,290.352s-.027.035-.1.077a.986.986,0,0,1-.331.12,2.4,2.4,0,0,1-1.261-.195,4.6,4.6,0,0,0-.822-.24,1.872,1.872,0,0,0-.941.108,10.322,10.322,0,0,0-1.933,1.176,5.968,5.968,0,0,0-1.6,1.573,8.36,8.36,0,0,1-1.023,1.582,2.468,2.468,0,0,1-.583.45,1.11,1.11,0,0,1-.547.126,1.318,1.318,0,0,1-.345-.063c-.075-.028-.113-.045-.111-.052s.165.041.455.035a1.075,1.075,0,0,0,.494-.146,2.466,2.466,0,0,0,.534-.45,9.092,9.092,0,0,0,.968-1.582,5.938,5.938,0,0,1,1.641-1.638c.334-.239.666-.457.989-.668a4.8,4.8,0,0,1,1-.519,2.021,2.021,0,0,1,1.03-.1,4.5,4.5,0,0,1,.844.272,2.5,2.5,0,0,0,1.2.251A2.1,2.1,0,0,0,323.141,290.352Z"
                            transform="translate(-313.548 -289.92)"
                            fill="#89544c"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4901"
                      data-name="Group 4901"
                      transform="translate(19.283 10.737)"
                    >
                      <g id="Group_4900" data-name="Group 4900">
                        <g id="Group_4899" data-name="Group 4899">
                          <path
                            id="Path_16137"
                            data-name="Path 16137"
                            d="M338.716,302.943a1.121,1.121,0,0,1-.292-.182,6.97,6.97,0,0,1-.72-.6,9.9,9.9,0,0,1-2.938-5.343,6.974,6.974,0,0,1-.119-.928,1.11,1.11,0,0,1,0-.344c.035,0,.08.482.257,1.243a11.086,11.086,0,0,0,2.9,5.27C338.352,302.616,338.738,302.914,338.716,302.943Z"
                            transform="translate(-334.638 -295.547)"
                            fill="#89544c"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group_4904"
                      data-name="Group 4904"
                      transform="translate(24.11 16.927)"
                    >
                      <g id="Group_4903" data-name="Group 4903">
                        <g id="Group_4902" data-name="Group 4902">
                          <path
                            id="Path_16138"
                            data-name="Path 16138"
                            d="M352.408,311.478a2.194,2.194,0,0,1-.555.679,4.769,4.769,0,0,1-3.959,1.172,2.2,2.2,0,0,1-.835-.267c.011-.034.328.069.854.125a5.251,5.251,0,0,0,3.846-1.139C352.17,311.715,352.38,311.456,352.408,311.478Z"
                            transform="translate(-347.06 -311.477)"
                            fill="#89544c"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4907"
                    data-name="Group 4907"
                    transform="translate(21.504 22.241)"
                  >
                    <g id="Group_4906" data-name="Group 4906">
                      <path
                        id="Path_16139"
                        data-name="Path 16139"
                        d="M356.163,370.78a9.245,9.245,0,0,1-12.8-1.179c-1.786-2.09-3.207-4.656-2.988-7.408.549-6.9.217-34.227.217-34.227l10.967-2.816s8.453,33.028,8.865,38.8C360.607,366.477,358.54,368.88,356.163,370.78Z"
                        transform="translate(-340.354 -325.15)"
                        fill="#b47266"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4923"
                  data-name="Group 4923"
                  transform="translate(6.609 84.504)"
                >
                  <g
                    id="Group_4910"
                    data-name="Group 4910"
                    transform="translate(0 18.932)"
                  >
                    <g id="Group_4909" data-name="Group 4909">
                      <path
                        id="Path_16140"
                        data-name="Path 16140"
                        d="M146.179,398.6h12.585l6.963-2.452,2.027-5.393a6.449,6.449,0,0,1,8.336.817c4.249,3.923,6.865,11.768,6.865,11.768l-11.278,3.923s-7.028,5.257-7.847,5.271-22.5.305-22.5.305S141.112,402.846,146.179,398.6Z"
                        transform="translate(-141.331 -389.585)"
                        fill="#b47266"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4912"
                    data-name="Group 4912"
                    transform="translate(32.162)"
                  >
                    <g id="Group_4911" data-name="Group 4911">
                      <path
                        id="Path_16141"
                        data-name="Path 16141"
                        d="M225.569,366.274,224.1,342.506a1.544,1.544,0,0,1,1.54-1.639H238.6a1.543,1.543,0,0,1,1.542,1.483l.936,23.768a1.543,1.543,0,0,1-1.542,1.6H227.109A1.543,1.543,0,0,1,225.569,366.274Z"
                        transform="translate(-224.093 -340.867)"
                        fill="#263238"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4915"
                    data-name="Group 4915"
                    transform="translate(32.453 1.028)"
                  >
                    <g id="Group_4914" data-name="Group 4914">
                      <g id="Group_4913" data-name="Group 4913">
                        <path
                          id="Path_16142"
                          data-name="Path 16142"
                          d="M240.041,357.2a1.544,1.544,0,0,1-.026-.288c-.009-.209-.021-.484-.036-.827-.023-.741-.054-1.774-.094-3.042-.032-1.292-.07-2.819-.113-4.512-.019-.85-.039-1.741-.06-2.665a4.444,4.444,0,0,0-.153-1.362,1.117,1.117,0,0,0-.379-.53,1.356,1.356,0,0,0-.632-.23,12.623,12.623,0,0,0-1.435-.007l-1.41.029-2.665.053-4.513.077-1.734.023A5.614,5.614,0,0,0,225.5,344a.881.881,0,0,0-.591.5.9.9,0,0,0-.049.277.442.442,0,0,1,.01-.291.91.91,0,0,1,.606-.559,5.352,5.352,0,0,1,1.312-.12l1.733-.053,4.512-.12,2.665-.065,1.41-.032a12.424,12.424,0,0,1,1.466.008,1.552,1.552,0,0,1,.725.268,1.321,1.321,0,0,1,.449.624,4.578,4.578,0,0,1,.162,1.427c.017.924.033,1.815.048,2.665.026,1.694.05,3.221.07,4.513.012,1.268.022,2.3.029,3.044,0,.344,0,.619,0,.828A1.552,1.552,0,0,1,240.041,357.2Z"
                          transform="translate(-224.843 -343.512)"
                          fill="#455a64"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4917"
                    data-name="Group 4917"
                    transform="translate(38.65 4.982)"
                  >
                    <g id="Group_4916" data-name="Group 4916">
                      <path
                        id="Path_16143"
                        data-name="Path 16143"
                        d="M242.561,354.2a.822.822,0,0,0-.853-.481.737.737,0,0,0-.915.624.937.937,0,0,0,.7.943.954.954,0,0,0,.894-.207A.779.779,0,0,0,242.561,354.2Z"
                        transform="translate(-240.789 -353.688)"
                        fill="#e0e0e0"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4919"
                    data-name="Group 4919"
                    transform="translate(26.174 10.209)"
                  >
                    <g id="Group_4918" data-name="Group 4918">
                      <path
                        id="Path_16144"
                        data-name="Path 16144"
                        d="M208.685,377.688v-2.419s2.376-5.6,2.308-5.391,4.214-2.741,4.214-2.741a11.924,11.924,0,0,1-.141,3.7,6.311,6.311,0,0,1-1.411,2.457l-.336,2.612,5.386-4.387,6.415-3.377a2.21,2.21,0,0,1,1.979.921c.819,1.092-.342,2.184-.887,2.525s-5.46,3.89-5.46,3.89l-2.719,3.136.579.661,4.8-3.046s6.074-4.436,7.439-4.709l.076-.014a1.269,1.269,0,0,1,1.2,2.029c-1.671,2.173-4.548,5.867-4.692,5.74-.2-.18-6.443,4.12-6.443,4.12s6.239-2.048,6.785-2.525,6.142-6.415,6.142-6.415.751.136.887,1.843L234.469,378s.136.41.341,1.3-2.935,6.961-2.935,6.961-12.284,6.756-13.444,6.825-5.459,0-5.459,0Z"
                        transform="translate(-208.685 -367.137)"
                        fill="#b47266"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4922"
                    data-name="Group 4922"
                    transform="translate(41.427 20.856)"
                  >
                    <g id="Group_4921" data-name="Group 4921">
                      <g id="Group_4920" data-name="Group 4920">
                        <path
                          id="Path_16145"
                          data-name="Path 16145"
                          d="M258.365,394.536a2.219,2.219,0,0,1-.236.52,11.759,11.759,0,0,1-.851,1.3c-.387.531-.869,1.137-1.359,1.851a14.393,14.393,0,0,1-1.839,2.147,19.124,19.124,0,0,1-4.233,2.881c-.58.3-1.056.537-1.387.694a3.045,3.045,0,0,1-.523.224,3.09,3.09,0,0,1,.487-.294l1.355-.749a21.019,21.019,0,0,0,4.162-2.9,15.086,15.086,0,0,0,1.827-2.109c.5-.708,1-1.312,1.4-1.827s.7-.947.9-1.255A4.9,4.9,0,0,1,258.365,394.536Z"
                          transform="translate(-247.937 -394.535)"
                          fill="#89544c"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4926"
                  data-name="Group 4926"
                  transform="translate(6.602 111.055)"
                >
                  <g id="Group_4925" data-name="Group 4925">
                    <g id="Group_4924" data-name="Group 4924">
                      <path
                        id="Path_16146"
                        data-name="Path 16146"
                        d="M148.719,409.192a11.363,11.363,0,0,0-2.263,1.4,12.279,12.279,0,0,0-3.573,5.254,26.339,26.339,0,0,0-1.289,6.306l-.185,1.953c-.022.211-.04.386-.055.531a.662.662,0,0,1-.033.184.649.649,0,0,1-.008-.187c0-.146.01-.322.017-.534.02-.463.055-1.134.121-1.961a24.453,24.453,0,0,1,1.241-6.362,11.989,11.989,0,0,1,3.673-5.3,8.113,8.113,0,0,1,1.677-1.036,5.044,5.044,0,0,1,.5-.2A.666.666,0,0,1,148.719,409.192Z"
                        transform="translate(-141.313 -409.191)"
                        fill="#263238"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="Desk" transform="translate(-462 7011.099)">
              <g
                id="Group_4930"
                data-name="Group 4930"
                transform="translate(22.19 0)"
              >
                <g id="Group_4929" data-name="Group 4929">
                  <g id="Group_4928" data-name="Group 4928">
                    <path
                      id="Path_16147"
                      data-name="Path 16147"
                      d="M80.166,336.2"
                      transform="translate(-80.166 -336.195)"
                      fill="none"
                      stroke="#4e585d"
                      stroke-miterlimit="10"
                      stroke-width="1"
                    />
                  </g>
                </g>
              </g>
              <g
                id="Group_4933"
                data-name="Group 4933"
                transform="translate(0 43.957)"
              >
                <g id="Group_4932" data-name="Group 4932">
                  <g id="Group_4931" data-name="Group 4931">
                    <path
                      id="Path_16148"
                      data-name="Path 16148"
                      d="M203.965,449.41c0,.056-40.5.1-90.445.1-49.964,0-90.454-.045-90.454-.1s40.49-.1,90.454-.1C163.466,449.309,203.965,449.354,203.965,449.41Z"
                      transform="translate(-23.065 -449.309)"
                      fill="#263238"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="Device" transform="translate(-377.426 7017.378)">
              <g
                id="Group_4948"
                data-name="Group 4948"
                transform="translate(0 0)"
              >
                <g
                  id="Group_4935"
                  data-name="Group 4935"
                  transform="translate(0.018 38.4)"
                >
                  <g id="Group_4934" data-name="Group 4934">
                    <path
                      id="Path_16149"
                      data-name="Path 16149"
                      d="M293.479,451.167l-52.734.359,33.818,7.289,12.312-3.069Z"
                      transform="translate(-240.745 -451.167)"
                      fill="#e0e0e0"
                    />
                  </g>
                </g>
                <g id="Group_4941" data-name="Group 4941">
                  <g
                    id="Group_4937"
                    data-name="Group 4937"
                    transform="translate(0.017 0.099)"
                  >
                    <g id="Group_4936" data-name="Group 4936">
                      <path
                        id="Path_16150"
                        data-name="Path 16150"
                        d="M240.745,393.379l33.818,8.4,51.993-4.006,10.276-41.317c.749-2.492-.511-3.853-2.1-3.847l-48.5,2.4a3.4,3.4,0,0,0-3.137,2.7l-8.528,40.848-33.818-7.289Z"
                        transform="translate(-240.745 -352.609)"
                        fill="#ebebeb"
                      />
                    </g>
                  </g>
                  <g id="Group_4940" data-name="Group 4940">
                    <g id="Group_4939" data-name="Group 4939">
                      <g id="Group_4938" data-name="Group 4938">
                        <path
                          id="Path_16151"
                          data-name="Path 16151"
                          d="M240.717,393.222s0-.168-.008-.517-.005-.881-.01-1.593v-.022l.021,0,33.828,7.239-.083.054c1.225-5.884,2.58-12.4,4.045-19.438q1.1-5.281,2.28-10.946.59-2.829,1.2-5.747l.612-2.938q.154-.74.309-1.484a3.877,3.877,0,0,1,.533-1.454,3.478,3.478,0,0,1,2.606-1.6c1.04-.066,2.076-.107,3.124-.163l6.355-.316,13.135-.654,13.637-.677,6.983-.346,3.529-.175,1.773-.088a2.306,2.306,0,0,1,2.483,1.918,3.949,3.949,0,0,1-.039,1.547l-.732,2.939-1.446,5.814-2.835,11.395-5.394,21.669-.017.066-.068.005L274.54,401.69h-.011l-.01,0-24.846-6.208-6.659-1.672-1.718-.435c-.385-.1-.579-.152-.579-.152s.2.045.594.14l1.732.422,6.68,1.642,24.829,6.131-.021,0,51.99-4.033-.085.072,5.386-21.673,2.833-11.4,1.446-5.814.729-2.927a3.75,3.75,0,0,0,.038-1.467,2.23,2.23,0,0,0-.694-1.247c-.9-.805-2.206-.41-3.358-.42l-3.528.175-6.982.345-13.635.674-13.134.648-6.354.313c-1.045.054-2.091.1-3.115.16a3.293,3.293,0,0,0-2.467,1.516,3.7,3.7,0,0,0-.509,1.393q-.156.745-.311,1.484-.309,1.479-.614,2.938-.61,2.916-1.2,5.746l-2.29,10.944-4.07,19.433-.014.069-.069-.015-33.806-7.34.021-.017c0,.708-.008,1.233-.01,1.584S240.717,393.222,240.717,393.222Z"
                          transform="translate(-240.7 -352.353)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4947"
                  data-name="Group 4947"
                  transform="translate(64.334 20.789)"
                >
                  <g
                    id="Group_4943"
                    data-name="Group 4943"
                    transform="translate(0.087 0.025)"
                  >
                    <g id="Group_4942" data-name="Group 4942">
                      <path
                        id="Path_16152"
                        data-name="Path 16152"
                        d="M408.884,405.943a2.939,2.939,0,0,0-2.29,1.829,2.223,2.223,0,0,0,.974,2.646,2.528,2.528,0,0,0,3.113-1.129,2.781,2.781,0,0,0,.246-2.218,2.087,2.087,0,0,0-2.043-1.128"
                        transform="translate(-406.476 -405.914)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g id="Group_4946" data-name="Group 4946">
                    <g id="Group_4945" data-name="Group 4945">
                      <g id="Group_4944" data-name="Group 4944">
                        <path
                          id="Path_16153"
                          data-name="Path 16153"
                          d="M408.746,405.9a.829.829,0,0,1,.574-.022,2.556,2.556,0,0,1,.643.222,2.021,2.021,0,0,1,.716.561,1.258,1.258,0,0,1,.224.493,3.143,3.143,0,0,1,.088.567,2.77,2.77,0,0,1-.2,1.247,2.893,2.893,0,0,1-2.238,1.693,1.988,1.988,0,0,1-1.454-.382,2.211,2.211,0,0,1-.762-1.176,2.4,2.4,0,0,1,0-1.267,2.536,2.536,0,0,1,.533-.964,3.071,3.071,0,0,1,1.311-.862,2.768,2.768,0,0,1,.415-.1.41.41,0,0,1,.149-.01c0,.018-.2.052-.537.185a3.168,3.168,0,0,0-1.23.881,2.428,2.428,0,0,0-.48.915,2.253,2.253,0,0,0,.016,1.173,2.038,2.038,0,0,0,.7,1.069,1.8,1.8,0,0,0,1.31.338,2.734,2.734,0,0,0,2.09-1.565,2.636,2.636,0,0,0,.206-1.165,1.9,1.9,0,0,0-.26-.984,1.956,1.956,0,0,0-.653-.545,2.739,2.739,0,0,0-.608-.246A1.635,1.635,0,0,0,408.746,405.9Z"
                          transform="translate(-406.251 -405.849)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="Calendar" transform="translate(-457.354 6950.891)">
              <g
                id="Group_5022"
                data-name="Group 5022"
                transform="translate(0 0)"
              >
                <g
                  id="Group_4975"
                  data-name="Group 4975"
                  transform="translate(14.827 9.409)"
                >
                  <g
                    id="Group_4950"
                    data-name="Group 4950"
                    transform="translate(0.101 3.201)"
                  >
                    <g id="Group_4949" data-name="Group 4949">
                      <path
                        id="Path_16154"
                        data-name="Path 16154"
                        d="M102.6,213.711H75.877a2.445,2.445,0,0,0-2.444,2.445v26.723a2.444,2.444,0,0,0,2.444,2.444H94.366l7.436,6.124v-6.124h.8a2.444,2.444,0,0,0,2.444-2.444V216.156A2.445,2.445,0,0,0,102.6,213.711Z"
                        transform="translate(-73.433 -213.711)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_4959"
                    data-name="Group 4959"
                    transform="translate(0.101 3.201)"
                  >
                    <g id="Group_4952" data-name="Group 4952">
                      <g id="Group_4951" data-name="Group 4951">
                        <path
                          id="Rectangle_2769"
                          data-name="Rectangle 2769"
                          d="M7.044,0H25.606a6.007,6.007,0,0,1,6.007,6.007V9.752a.229.229,0,0,1-.229.229H.229A.229.229,0,0,1,0,9.752V7.044A7.044,7.044,0,0,1,7.044,0Z"
                          fill={primaryColor}
                        />
                      </g>
                    </g>
                    <g
                      id="Group_4955"
                      data-name="Group 4955"
                      transform="translate(8.998 14.691)"
                    >
                      <g id="Group_4953" data-name="Group 4953">
                        <path
                          id="Path_16155"
                          data-name="Path 16155"
                          d="M101.223,251.516v10.746H98.736v-8.75H96.587v-2Z"
                          transform="translate(-96.587 -251.516)"
                          fill="#263238"
                        />
                      </g>
                      <g
                        id="Group_4954"
                        data-name="Group 4954"
                        transform="translate(6.31)"
                      >
                        <path
                          id="Path_16156"
                          data-name="Path 16156"
                          d="M121.437,251.516v1.612l-3.992,9.134h-2.7l3.853-8.719h-3.562v1.75h-2.21v-3.777Z"
                          transform="translate(-112.825 -251.516)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_4958"
                      data-name="Group 4958"
                      transform="translate(10.519 5.561)"
                    >
                      <g id="Group_4957" data-name="Group 4957">
                        <g id="Group_4956" data-name="Group 4956">
                          <path
                            id="Path_16157"
                            data-name="Path 16157"
                            d="M110.2,228.122c0,.056-2.172.1-4.851.1s-4.851-.045-4.851-.1,2.172-.1,4.851-.1S110.2,228.066,110.2,228.122Z"
                            transform="translate(-100.502 -228.021)"
                            fill="#263238"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4962"
                    data-name="Group 4962"
                    transform="translate(0 3.119)"
                  >
                    <g id="Group_4961" data-name="Group 4961">
                      <g id="Group_4960" data-name="Group 4960">
                        <path
                          id="Path_16158"
                          data-name="Path 16158"
                          d="M102.443,213.582s.055,0,.165,0a2.067,2.067,0,0,1,.483.074,2.426,2.426,0,0,1,1.488,1.127,2.511,2.511,0,0,1,.344,1.344q0,.765.007,1.667c0,1.2.007,2.584.012,4.128.006,3.091.013,6.835.021,11.117,0,2.142.005,4.418.009,6.814q0,.9,0,1.819v.926a2.805,2.805,0,0,1-.13.951,2.53,2.53,0,0,1-2.214,1.724c-.337.019-.654.006-.984.01l.09-.09c0,1.931,0,4,0,6.124v.2l-.154-.127-7.439-6.12.063.023-14.325,0h-3.36l-.835,0a2.549,2.549,0,0,1-2.146-1.231,2.579,2.579,0,0,1-.314-.791,4.033,4.033,0,0,1-.054-.836v-1.627q0-1.621,0-3.215c0-4.25,0-8.35.006-12.256q0-2.929,0-5.707,0-1.388,0-2.734a9.2,9.2,0,0,1,.048-1.348,2.539,2.539,0,0,1,1.7-1.923,3.861,3.861,0,0,1,1.281-.123l2.466,0,4.636.007,13.991.032,3.8.019.989.01c.223,0,.337.01.337.01s-.114.007-.337.01l-.989.01-3.8.019-13.991.032-4.636.007-2.466,0a3.717,3.717,0,0,0-1.23.118,2.371,2.371,0,0,0-1.586,1.8,9.16,9.16,0,0,0-.042,1.316q0,1.347,0,2.734,0,2.775,0,5.707c0,3.906,0,8.006.006,12.256q0,1.594,0,3.215v1.627a3.844,3.844,0,0,0,.05.795,2.371,2.371,0,0,0,.289.729,2.32,2.32,0,0,0,1.2.989,4.526,4.526,0,0,0,1.611.146h3.36l14.325,0h.035l.027.023,7.433,6.127-.154.073c0-2.124,0-4.193,0-6.124v-.089h.089c.325,0,.661.009.972-.008a2.354,2.354,0,0,0,2.063-1.6,2.62,2.62,0,0,0,.123-.9v-.926q0-.92,0-1.819c0-2.4.006-4.672.009-6.814.008-4.282.015-8.026.021-11.117,0-1.544.009-2.924.012-4.128-.033-1.19.157-2.266-.316-2.983a2.414,2.414,0,0,0-1.446-1.128A3.567,3.567,0,0,0,102.443,213.582Z"
                          transform="translate(-73.174 -213.5)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4968"
                    data-name="Group 4968"
                    transform="translate(19.459)"
                  >
                    <g
                      id="Group_4964"
                      data-name="Group 4964"
                      transform="translate(0.102 0.102)"
                    >
                      <g id="Group_4963" data-name="Group 4963">
                        <rect
                          id="Rectangle_2770"
                          data-name="Rectangle 2770"
                          width="2.057"
                          height="7.14"
                          rx="1.029"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                    <g id="Group_4967" data-name="Group 4967">
                      <g id="Group_4966" data-name="Group 4966">
                        <g id="Group_4965" data-name="Group 4965">
                          <path
                            id="Path_16159"
                            data-name="Path 16159"
                            d="M124.413,212.717a1.266,1.266,0,0,0,.584-.24.96.96,0,0,0,.344-.626c.014-.283,0-.637-.005-1.01-.006-.766-.014-1.662-.022-2.652,0-.5,0-1.024-.006-1.566a.9.9,0,0,0-.963-.945.9.9,0,0,0-.676.309.945.945,0,0,0-.22.7c0,.542,0,1.066-.006,1.566-.008.989-.015,1.886-.022,2.652q0,.282-.007.538a2.626,2.626,0,0,0,.012.467.973.973,0,0,0,.386.6,1.313,1.313,0,0,0,.6.2.437.437,0,0,1-.171.015.984.984,0,0,1-.473-.151,1.043,1.043,0,0,1-.453-.644,2.584,2.584,0,0,1-.03-.49q0-.256-.007-.538c-.006-.766-.014-1.662-.022-2.652,0-.5,0-1.024-.006-1.566a1.145,1.145,0,0,1,.266-.836,1.1,1.1,0,0,1,.828-.38,1.1,1.1,0,0,1,1.161,1.147c0,.542,0,1.066-.006,1.566-.008.989-.015,1.886-.022,2.652-.009.38,0,.712-.026,1.026a1.031,1.031,0,0,1-.407.672.958.958,0,0,1-.461.183A.378.378,0,0,1,124.413,212.717Z"
                            transform="translate(-123.248 -205.474)"
                            fill="#263238"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_4974"
                    data-name="Group 4974"
                    transform="translate(9.809)"
                  >
                    <g
                      id="Group_4970"
                      data-name="Group 4970"
                      transform="translate(0.102 0.102)"
                    >
                      <g id="Group_4969" data-name="Group 4969">
                        <rect
                          id="Rectangle_2771"
                          data-name="Rectangle 2771"
                          width="2.057"
                          height="7.14"
                          rx="1.029"
                          fill="#e0e0e0"
                        />
                      </g>
                    </g>
                    <g id="Group_4973" data-name="Group 4973">
                      <g id="Group_4972" data-name="Group 4972">
                        <g id="Group_4971" data-name="Group 4971">
                          <path
                            id="Path_16160"
                            data-name="Path 16160"
                            d="M99.58,212.717a1.266,1.266,0,0,0,.584-.24.96.96,0,0,0,.344-.626c.014-.283-.005-.637-.005-1.01-.006-.766-.014-1.662-.022-2.652,0-.5,0-1.024-.006-1.566a.9.9,0,0,0-.963-.945.9.9,0,0,0-.676.309.945.945,0,0,0-.22.7c0,.542,0,1.066-.006,1.566-.008.989-.016,1.886-.022,2.652q0,.282-.007.538a2.59,2.59,0,0,0,.012.467.973.973,0,0,0,.386.6,1.312,1.312,0,0,0,.6.2.437.437,0,0,1-.171.015.984.984,0,0,1-.473-.151,1.043,1.043,0,0,1-.453-.644,2.584,2.584,0,0,1-.03-.49q0-.256-.007-.538c-.006-.766-.014-1.662-.022-2.652,0-.5,0-1.024-.006-1.566a1.145,1.145,0,0,1,.266-.836,1.1,1.1,0,0,1,.828-.38,1.1,1.1,0,0,1,1.162,1.147c0,.542,0,1.066-.006,1.566-.008.989-.016,1.886-.022,2.652-.009.38,0,.712-.026,1.026a1.031,1.031,0,0,1-.407.672.958.958,0,0,1-.461.183A.378.378,0,0,1,99.58,212.717Z"
                            transform="translate(-98.415 -205.474)"
                            fill="#263238"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_4978"
                  data-name="Group 4978"
                  transform="translate(14.906 12.909)"
                  opacity="0.3"
                >
                  <g id="Group_4977" data-name="Group 4977">
                    <g id="Group_4976" data-name="Group 4976">
                      <path
                        id="Path_16161"
                        data-name="Path 16161"
                        d="M82.035,214.48A9.686,9.686,0,0,1,73.378,225.1l.39-5.31,4.816-5.235Z"
                        transform="translate(-73.378 -214.48)"
                      />
                    </g>
                  </g>
                </g>
                <g id="Group_5021" data-name="Group 5021">
                  <g
                    id="Group_4993"
                    data-name="Group 4993"
                    transform="translate(1.872 1.536)"
                  >
                    <g
                      id="Group_4980"
                      data-name="Group 4980"
                      transform="translate(0 0)"
                    >
                      <g id="Group_4979" data-name="Group 4979">
                        <circle
                          id="Ellipse_50"
                          data-name="Ellipse 50"
                          cx="9.06"
                          cy="9.06"
                          r="9.06"
                          transform="matrix(0.97, -0.244, 0.244, 0.97, 0, 4.429)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_4992"
                      data-name="Group 4992"
                      transform="translate(0.875 0.861)"
                    >
                      <g
                        id="Group_4982"
                        data-name="Group 4982"
                        transform="translate(0.085 0.1)"
                      >
                        <g id="Group_4981" data-name="Group 4981">
                          <path
                            id="Path_16162"
                            data-name="Path 16162"
                            d="M52.343,207.766a10.038,10.038,0,1,1,9.944-11.451h0a10.042,10.042,0,0,1-9.944,11.451Zm.024-18.123a8.152,8.152,0,0,0-1.154.082,8.083,8.083,0,1,0,9.14,6.865h0a8.086,8.086,0,0,0-7.986-6.947Z"
                            transform="translate(-42.31 -187.688)"
                            fill="#455a64"
                          />
                        </g>
                      </g>
                      <g id="Group_4991" data-name="Group 4991">
                        <g
                          id="Group_4984"
                          data-name="Group 4984"
                          transform="translate(0.085 0.1)"
                        >
                          <g id="Group_4983" data-name="Group 4983">
                            <path
                              id="Path_16163"
                              data-name="Path 16163"
                              d="M52.343,207.766a10.038,10.038,0,1,1,9.944-11.451h0a10.042,10.042,0,0,1-9.944,11.451Zm.024-18.123a8.152,8.152,0,0,0-1.154.082,8.083,8.083,0,1,0,9.14,6.865h0a8.086,8.086,0,0,0-7.986-6.947Z"
                              transform="translate(-42.31 -187.688)"
                              fill="none"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_4987"
                          data-name="Group 4987"
                          transform="translate(1.954 2.045)"
                        >
                          <g id="Group_4986" data-name="Group 4986">
                            <g id="Group_4985" data-name="Group 4985">
                              <path
                                id="Path_16164"
                                data-name="Path 16164"
                                d="M55.306,192.7a.645.645,0,0,1,.131-.007c.087,0,.216,0,.385.005a7.72,7.72,0,0,1,1.468.211,8.013,8.013,0,0,1,2.172.888,8.221,8.221,0,0,1,2.325,2.059,8.083,8.083,0,0,1,1.529,3.434,10.276,10.276,0,0,1,.123,1.033,4.419,4.419,0,0,1,.01.533c-.007.179.008.36-.016.541a8.678,8.678,0,0,1-.467,2.189,8.223,8.223,0,0,1-2.852,3.8,8.185,8.185,0,0,1-9.679-.022,8.9,8.9,0,0,1-1.735-1.736,8.108,8.108,0,0,1-1.562-4.268,8.085,8.085,0,0,1,1.674-5.531,8,8,0,0,1,4.507-2.927c.314-.073.6-.121.843-.153l.627-.035.385-.017a.637.637,0,0,1,.131,0,.647.647,0,0,1-.131.02l-.382.037-.621.054c-.243.038-.522.092-.832.17a8.244,8.244,0,0,0-2.14.893,8.106,8.106,0,0,0-2.273,2.044,7.993,7.993,0,0,0-1.5,3.37,7.885,7.885,0,0,0-.112,2.062,7.971,7.971,0,0,0,3.237,5.856,8,8,0,0,0,9.444.022,8.05,8.05,0,0,0,2.794-3.708,8.516,8.516,0,0,0,.464-2.137c.024-.176.01-.354.017-.529a4.237,4.237,0,0,0-.007-.522,10.133,10.133,0,0,0-.115-1.012,7.973,7.973,0,0,0-1.478-3.378A8.17,8.17,0,0,0,59.4,193.9a8.077,8.077,0,0,0-2.133-.909,8.424,8.424,0,0,0-1.451-.247C55.484,192.713,55.306,192.714,55.306,192.7Z"
                                transform="translate(-47.118 -192.694)"
                                fill="#263238"
                              />
                            </g>
                          </g>
                        </g>
                        <g id="Group_4990" data-name="Group 4990">
                          <g id="Group_4989" data-name="Group 4989">
                            <g id="Group_4988" data-name="Group 4988">
                              <path
                                id="Path_16165"
                                data-name="Path 16165"
                                d="M52.209,207.609a1.051,1.051,0,0,1,.163-.012l.476-.029c.209-.016.467-.043.77-.088l1.035-.213a10.953,10.953,0,0,0,2.659-1.116,10.285,10.285,0,0,0,2.826-2.545,10.086,10.086,0,0,0,1.852-4.2,4.286,4.286,0,0,0,.093-.621c.022-.21.049-.422.067-.636q0-.322.005-.649l0-.328-.031-.33a9.513,9.513,0,0,0-.56-2.663,9.966,9.966,0,0,0-9.343-6.547,9.945,9.945,0,0,0-9.358,6.536,10.125,10.125,0,0,0,.285,7.52,9.989,9.989,0,0,0,.53,1l.287.469.32.431a9.987,9.987,0,0,0,2.821,2.549,10.34,10.34,0,0,0,2.658,1.115,8.057,8.057,0,0,0,1.034.212,6.211,6.211,0,0,0,.769.091l.476.032a.955.955,0,0,1,.162.018.973.973,0,0,1-.163,0l-.478-.012a5.852,5.852,0,0,1-.775-.072,7.96,7.96,0,0,1-1.045-.2,10.237,10.237,0,0,1-2.7-1.095,10.03,10.03,0,0,1-2.877-2.559l-.328-.436-.295-.474a10.227,10.227,0,0,1-.544-1.015,10.257,10.257,0,0,1-.318-7.649,10.12,10.12,0,0,1,9.532-6.675,10.139,10.139,0,0,1,9.518,6.686,9.669,9.669,0,0,1,.562,2.713l.03.335,0,.335q0,.333-.009.661c-.018.218-.047.433-.07.647a4.367,4.367,0,0,1-.1.631,10.191,10.191,0,0,1-1.9,4.253,10.343,10.343,0,0,1-2.882,2.556,10.841,10.841,0,0,1-2.7,1.1l-1.046.2c-.305.04-.565.059-.776.07s-.371.011-.479.009S52.209,207.609,52.209,207.609Z"
                                transform="translate(-42.091 -187.431)"
                                fill="#263238"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_5000"
                    data-name="Group 5000"
                    transform="translate(16.513)"
                  >
                    <g id="Group_4999" data-name="Group 4999">
                      <g
                        id="Group_4995"
                        data-name="Group 4995"
                        transform="translate(0.136 0.089)"
                      >
                        <g
                          id="Group_4994"
                          data-name="Group 4994"
                          transform="translate(0 0)"
                        >
                          <rect
                            id="Rectangle_2772"
                            data-name="Rectangle 2772"
                            width="1.564"
                            height="6.264"
                            transform="translate(0 1.326) rotate(-57.989)"
                            fill="#455a64"
                          />
                        </g>
                      </g>
                      <g id="Group_4998" data-name="Group 4998">
                        <g id="Group_4997" data-name="Group 4997">
                          <g id="Group_4996" data-name="Group 4996">
                            <path
                              id="Path_16166"
                              data-name="Path 16166"
                              d="M82.96,186a3.613,3.613,0,0,1,.2-.378l.573-.98.019.083c-1.206-.724-3.151-1.921-5.333-3.285l.139-.033h0v0l0,0,0,.005-.007.01-.013.021-.027.043-.053.085-.106.169-.209.334-.41.652-.031-.137c1.5.94,2.8,1.779,3.739,2.391l1.11.727a4.262,4.262,0,0,1,.41.287,2.887,2.887,0,0,1-.4-.218l-1.121-.667c-.957-.575-2.31-1.4-3.846-2.351l-.084-.052.052-.085.407-.654.208-.335.105-.169.053-.085.026-.043.013-.021.007-.01,0-.005,0,0v0h0l.14-.032c2.182,1.364,4.11,2.588,5.289,3.355l.052.033-.032.05c-.277.427-.5.757-.649.975A2.493,2.493,0,0,1,82.96,186Z"
                              transform="translate(-77.512 -181.262)"
                              fill="#263238"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_5007"
                    data-name="Group 5007"
                    transform="translate(0.237 2.151)"
                  >
                    <g id="Group_5006" data-name="Group 5006">
                      <g
                        id="Group_5002"
                        data-name="Group 5002"
                        transform="translate(0.084 0.076)"
                      >
                        <g
                          id="Group_5001"
                          data-name="Group 5001"
                          transform="translate(0 0)"
                        >
                          <rect
                            id="Rectangle_2773"
                            data-name="Rectangle 2773"
                            width="6.593"
                            height="1.564"
                            transform="translate(0 4.952) rotate(-48.692)"
                            fill="#455a64"
                          />
                        </g>
                      </g>
                      <g id="Group_5005" data-name="Group 5005">
                        <g id="Group_5004" data-name="Group 5004">
                          <g id="Group_5003" data-name="Group 5003">
                            <path
                              id="Path_16167"
                              data-name="Path 16167"
                              d="M36.888,192.858a4.8,4.8,0,0,1,.327-.412l.9-1.068c.765-.9,1.826-2.14,3.049-3.539l.009.14L40,186.949c.285-.019.078,0,.141-.008v0l0,0-.005.006-.01.012-.021.024-.042.048-.084.1-.167.189-.329.374-.64.725-1.191,1.343-1.888,2.1-.005-.084.831.774a3.637,3.637,0,0,1,.3.3,2.517,2.517,0,0,1-.312-.239c-.206-.167-.513-.419-.9-.748l-.045-.038.04-.045,1.842-2.144,1.179-1.355.637-.728.328-.374.166-.19.084-.1.042-.048.021-.024.01-.012.005-.006,0,0,0,0a1.167,1.167,0,1,1,.144-.01l1.173,1.033.075.066-.066.075c-1.257,1.424-2.371,2.661-3.162,3.532l-.928,1.013A3.152,3.152,0,0,1,36.888,192.858Z"
                              transform="translate(-35.63 -186.797)"
                              fill="#263238"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_5014"
                    data-name="Group 5014"
                    transform="translate(8.909 7.682)"
                  >
                    <g id="Group_5013" data-name="Group 5013">
                      <g id="Group_5012" data-name="Group 5012">
                        <g id="Group_5011" data-name="Group 5011">
                          <g id="Group_5010" data-name="Group 5010">
                            <g
                              id="Group_5008"
                              data-name="Group 5008"
                              transform="translate(0.014 0.013)"
                            >
                              <path
                                id="Path_16168"
                                data-name="Path 16168"
                                d="M57.981,206.7l.772-1.472,2.763,1.249,2.973-5.411,1.391.8-3.851,6.827Z"
                                transform="translate(-57.981 -201.065)"
                                fill="#455a64"
                              />
                            </g>
                            <g id="Group_5009" data-name="Group 5009">
                              <path
                                id="Path_16169"
                                data-name="Path 16169"
                                d="M62.013,208.681l-.009,0-4.059-2,.005-.009.776-1.48.008,0,2.755,1.245,2.974-5.411.009,0,1.4.8,0,.008Zm-4.04-2.008L62,208.656l3.841-6.811-1.374-.787-2.973,5.41-.008,0-2.755-1.245Z"
                                transform="translate(-57.946 -201.031)"
                                fill="#263238"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_5017"
                    data-name="Group 5017"
                    transform="translate(1.082 14.606)"
                  >
                    <g id="Group_5016" data-name="Group 5016">
                      <g id="Group_5015" data-name="Group 5015">
                        <path
                          id="Path_16170"
                          data-name="Path 16170"
                          d="M44.2,227.964a2.022,2.022,0,0,1-.422-.178,4.476,4.476,0,0,1-.475-.251c-.18-.107-.392-.22-.607-.375A10.9,10.9,0,0,1,41.245,226a11.437,11.437,0,0,1-2.6-3.708,10.9,10.9,0,0,1-.6-1.759c-.073-.254-.106-.492-.145-.7a4.412,4.412,0,0,1-.073-.532,1.958,1.958,0,0,1-.023-.457c.04-.005.1.645.379,1.651a12.135,12.135,0,0,0,.627,1.719,12.088,12.088,0,0,0,2.557,3.65,12.187,12.187,0,0,0,1.4,1.176C43.626,227.65,44.217,227.928,44.2,227.964Z"
                          transform="translate(-37.804 -218.847)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_5020"
                    data-name="Group 5020"
                    transform="translate(0 15.636)"
                  >
                    <g id="Group_5019" data-name="Group 5019">
                      <g id="Group_5018" data-name="Group 5018">
                        <path
                          id="Path_16171"
                          data-name="Path 16171"
                          d="M37.912,227.515a3.737,3.737,0,0,1-.649-.748,12.779,12.779,0,0,1-2.06-4.294,3.753,3.753,0,0,1-.178-.975,6.733,6.733,0,0,1,.315.934,17.134,17.134,0,0,0,2.039,4.252A6.676,6.676,0,0,1,37.912,227.515Z"
                          transform="translate(-35.02 -221.498)"
                          fill="#263238"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="Speech_Bubble"
              data-name="Speech Bubble"
              transform="translate(-334.891 6927.093)"
            >
              <g
                id="Group_5031"
                data-name="Group 5031"
                transform="translate(0 0)"
              >
                <g id="Group_5029" data-name="Group 5029">
                  <g id="Group_5028" data-name="Group 5028">
                    <g
                      id="Group_5024"
                      data-name="Group 5024"
                      transform="translate(0 0.075)"
                    >
                      <g id="Group_5023" data-name="Group 5023">
                        <path
                          id="Path_16172"
                          data-name="Path 16172"
                          d="M350.155,159.323l4.372-7.705a20.644,20.644,0,1,1,4.945,5.5l.007.009Z"
                          transform="translate(-350.155 -120.214)"
                          fill="#fafafa"
                        />
                      </g>
                    </g>
                    <g id="Group_5027" data-name="Group 5027">
                      <g id="Group_5026" data-name="Group 5026">
                        <g id="Group_5025" data-name="Group 5025">
                          <path
                            id="Path_16173"
                            data-name="Path 16173"
                            d="M350.155,159.205l9.313-2.245-.028.08-.007-.009a.051.051,0,0,1,.009-.071.051.051,0,0,1,.062,0,21.11,21.11,0,0,0,4.226,2.52,20.6,20.6,0,0,0,5.618,1.582,18.445,18.445,0,0,0,3.239.153c.557-.033,1.124-.048,1.7-.1l1.726-.265a20.637,20.637,0,0,0,12.747-8.216,20.367,20.367,0,0,0,3.439-7.886,20.818,20.818,0,0,0-.247-9.073c-.1-.377-.188-.759-.3-1.135l-.406-1.108a18.5,18.5,0,0,0-.963-2.17,9.607,9.607,0,0,0-.59-1.04c-.209-.34-.412-.687-.628-1.025l-.723-.967-.363-.485c-.12-.163-.267-.3-.4-.455l-.833-.916c-.274-.309-.6-.562-.9-.845l-.455-.413a4.2,4.2,0,0,0-.469-.393l-.979-.732c-.165-.117-.319-.253-.494-.355l-.519-.315-1.034-.629-1.083-.526a9.516,9.516,0,0,0-1.094-.487,20.838,20.838,0,0,0-9.141-1.411,20.147,20.147,0,0,0-8.4,2.471,20.756,20.756,0,0,0-9.717,11.912,22.183,22.183,0,0,0-.908,6.649,20.436,20.436,0,0,0,.98,5.752,20.932,20.932,0,0,0,2.033,4.421.049.049,0,0,1,0,.049l-4.415,7.682,4.33-7.729v.049a20.909,20.909,0,0,1-2.064-4.435,20.489,20.489,0,0,1-1.006-5.785,22.266,22.266,0,0,1,.9-6.7,20.9,20.9,0,0,1,9.778-12.027,20.316,20.316,0,0,1,8.473-2.5,21.013,21.013,0,0,1,9.231,1.419,9.59,9.59,0,0,1,1.1.491c.363.177.731.348,1.094.531l1.045.634.524.318c.177.1.332.24.5.358l.988.739a4.284,4.284,0,0,1,.474.4l.459.417c.3.286.629.542.905.853l.841.925c.134.154.283.3.4.46l.366.49.73.977c.219.341.423.691.634,1.035a9.673,9.673,0,0,1,.6,1.05,18.776,18.776,0,0,1,.973,2.192l.409,1.119c.112.379.2.765.3,1.146a20.993,20.993,0,0,1,.244,9.16,20.529,20.529,0,0,1-3.479,7.956,20.783,20.783,0,0,1-12.868,8.264l-1.74.263c-.576.049-1.147.062-1.708.094a18.538,18.538,0,0,1-3.262-.164,20.67,20.67,0,0,1-5.649-1.611,21.1,21.1,0,0,1-4.238-2.552l.071-.071.007.009a.05.05,0,0,1-.009.07.047.047,0,0,1-.019.009Z"
                            transform="translate(-350.155 -120.022)"
                            fill="#263238"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Group_5030"
                  data-name="Group 5030"
                  transform="translate(18.84 9.692)"
                >
                  <path
                    id="Path_16174"
                    data-name="Path 16174"
                    d="M404.06,146.474l-.689,10.882a1.766,1.766,0,0,1-1.657,1.651h0a1.766,1.766,0,0,1-1.86-1.569L398.646,146.5a1.386,1.386,0,0,1,1.4-1.538L402.7,145A1.386,1.386,0,0,1,404.06,146.474Z"
                    transform="translate(-398.637 -144.964)"
                    fill={primaryColor}
                  />
                  <path
                    id="Path_16175"
                    data-name="Path 16175"
                    d="M400.388,191.356A2.656,2.656,0,1,0,402.072,188,2.656,2.656,0,0,0,400.388,191.356Z"
                    transform="translate(-399.625 -171.192)"
                    fill={primaryColor}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
